var map = {
	"./CurrencyManagement": 1045,
	"./CurrencyManagement.js": 1045,
	"./TRM": 1046,
	"./TRM.js": 1046,
	"./TRM/filter": 173,
	"./TRM/filter.js": 173,
	"./TRM/table": 174,
	"./TRM/table.js": 174,
	"./accounting/accounts": 1047,
	"./accounting/accounts.js": 1047,
	"./accounting/accounts/filter": 175,
	"./accounting/accounts/filter.js": 175,
	"./accounting/accounts/table": 176,
	"./accounting/accounts/table.js": 176,
	"./accounting/area": 1048,
	"./accounting/area.js": 1048,
	"./accounting/area/filter": 1001,
	"./accounting/area/filter.js": 1001,
	"./accounting/area/table": 177,
	"./accounting/area/table.js": 177,
	"./accounting/area_copy": 1049,
	"./accounting/area_copy.js": 1049,
	"./accounting/closingDayReport": 1050,
	"./accounting/closingDayReport.js": 1050,
	"./accounting/closingDayReport/filter": 178,
	"./accounting/closingDayReport/filter.js": 178,
	"./accounting/closingDayReport/table": 179,
	"./accounting/closingDayReport/table.js": 179,
	"./accounting/concepts": 1051,
	"./accounting/concepts.js": 1051,
	"./accounting/concepts/filter": 180,
	"./accounting/concepts/filter.js": 180,
	"./accounting/concepts/table": 181,
	"./accounting/concepts/table.js": 181,
	"./accounting/costCenter": 1052,
	"./accounting/costCenter.js": 1052,
	"./accounting/costCenter/filter": 182,
	"./accounting/costCenter/filter.js": 182,
	"./accounting/costCenter/table": 183,
	"./accounting/costCenter/table.js": 183,
	"./accounting/employees": 1053,
	"./accounting/employees.js": 1053,
	"./accounting/employees/filter": 1002,
	"./accounting/employees/filter.js": 1002,
	"./accounting/employees/table": 184,
	"./accounting/employees/table.js": 184,
	"./accounting/expenses": 1054,
	"./accounting/expenses.js": 1054,
	"./accounting/expenses/filter": 185,
	"./accounting/expenses/filter.js": 185,
	"./accounting/expenses/table": 186,
	"./accounting/expenses/table.js": 186,
	"./accounting/incomes": 1055,
	"./accounting/incomes.js": 1055,
	"./accounting/incomes/filter": 187,
	"./accounting/incomes/filter.js": 187,
	"./accounting/incomes/table": 188,
	"./accounting/incomes/table.js": 188,
	"./accounting/position": 1056,
	"./accounting/position.js": 1056,
	"./accounting/position/filter": 1003,
	"./accounting/position/filter.js": 1003,
	"./accounting/position/table": 189,
	"./accounting/position/table.js": 189,
	"./accounting/productsThirdBetShop": 1057,
	"./accounting/productsThirdBetShop.js": 1057,
	"./accounting/productsThirdBetShop/filter": 1004,
	"./accounting/productsThirdBetShop/filter.js": 1004,
	"./accounting/productsThirdBetShop/table": 190,
	"./accounting/productsThirdBetShop/table.js": 190,
	"./accounting/productsThirdByBetShop": 1058,
	"./accounting/productsThirdByBetShop.js": 1058,
	"./accounting/productsThirdByBetShop/filter": 191,
	"./accounting/productsThirdByBetShop/filter.js": 191,
	"./accounting/productsThirdByBetShop/table": 192,
	"./accounting/productsThirdByBetShop/table.js": 192,
	"./accounting/productsThirdQuota": 1059,
	"./accounting/productsThirdQuota.js": 1059,
	"./accounting/productsThirdQuota/filter": 193,
	"./accounting/productsThirdQuota/filter.js": 193,
	"./accounting/productsThirdQuota/table": 194,
	"./accounting/productsThirdQuota/table.js": 194,
	"./accounting/providers": 1060,
	"./accounting/providers.js": 1060,
	"./accounting/providers/filter": 1005,
	"./accounting/providers/filter.js": 1005,
	"./accounting/providers/table": 195,
	"./accounting/providers/table.js": 195,
	"./accounting/providers/tableProductsThirdBetShop": 1061,
	"./accounting/providers/tableProductsThirdBetShop.js": 1061,
	"./accounting/providers_copy": 1062,
	"./accounting/providers_copy.js": 1062,
	"./accounting/squareDayReport": 1063,
	"./accounting/squareDayReport.js": 1063,
	"./accounting/squareDayReport/filter": 196,
	"./accounting/squareDayReport/filter.js": 196,
	"./accounting/squareDayReport/table": 197,
	"./accounting/squareDayReport/table.js": 197,
	"./accounting/squareDayReport2": 1064,
	"./accounting/squareDayReport2.js": 1064,
	"./accounting/squareDayReport2/filter": 198,
	"./accounting/squareDayReport2/filter.js": 198,
	"./accounting/squareDayReport2/table": 199,
	"./accounting/squareDayReport2/table.js": 199,
	"./accounting/typeCenterPosition": 1065,
	"./accounting/typeCenterPosition.js": 1065,
	"./accounting/typeDocument": 1066,
	"./accounting/typeDocument.js": 1066,
	"./accounting/typeDocument/filter": 201,
	"./accounting/typeDocument/filter.js": 201,
	"./accounting/typeDocument/table": 202,
	"./accounting/typeDocument/table.js": 202,
	"./accounting/types/filter": 1006,
	"./accounting/types/filter.js": 1006,
	"./accounting/types/table": 200,
	"./accounting/types/table.js": 200,
	"./activateRegistration": 1067,
	"./activateRegistration.js": 1067,
	"./activeProviders": 1068,
	"./activeProviders.js": 1068,
	"./addAdminUserManagement": 1069,
	"./addAdminUserManagement.js": 1069,
	"./addAgentListManagement": 1070,
	"./addAgentListManagement.js": 1070,
	"./addBetShopManagement": 1071,
	"./addBetShopManagement.js": 1071,
	"./adminUser": 1072,
	"./adminUser.js": 1072,
	"./adminUserManagement": 1073,
	"./adminUserManagement.js": 1073,
	"./affiliatesBetShop": 1074,
	"./affiliatesBetShop.js": 1074,
	"./agent/addInformationAgentList": 1075,
	"./agent/addInformationAgentList.js": 1075,
	"./agent/age": 1076,
	"./agent/age.js": 1076,
	"./agent/agent-list/detailsAgentList": 211,
	"./agent/agent-list/detailsAgentList.js": 211,
	"./agent/agent-list/filterAgentList": 212,
	"./agent/agent-list/filterAgentList.js": 212,
	"./agent/agent-list/recordAgentList": 213,
	"./agent/agent-list/recordAgentList.js": 213,
	"./agent/agent-list/recordTableAgentList": 1007,
	"./agent/agent-list/recordTableAgentList.js": 1007,
	"./agent/agent-list/tableAgentList": 214,
	"./agent/agent-list/tableAgentList.js": 214,
	"./agent/agent-retraction/PagoPremio": 215,
	"./agent/agent-retraction/PagoPremio.js": 215,
	"./agent/agent-retraction/search": 216,
	"./agent/agent-retraction/search.js": 216,
	"./agent/agent-retraction/transfers": 217,
	"./agent/agent-retraction/transfers.js": 217,
	"./agent/agent-retraction/transfers1": 218,
	"./agent/agent-retraction/transfers1.js": 218,
	"./agent/agent-transfers/PagoPremio": 219,
	"./agent/agent-transfers/PagoPremio.js": 219,
	"./agent/agent-transfers/search": 220,
	"./agent/agent-transfers/search.js": 220,
	"./agent/agent-transfers/transfers": 221,
	"./agent/agent-transfers/transfers.js": 221,
	"./agent/agent-transfers/transfers1": 222,
	"./agent/agent-transfers/transfers1.js": 222,
	"./agent/agent-tree/details": 1008,
	"./agent/agent-tree/details.js": 1008,
	"./agent/agent-tree/filter": 223,
	"./agent/agent-tree/filter.js": 223,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 224,
	"./agent/agent-tree/recordTableAgentList.js": 224,
	"./agent/agent-tree/table": 225,
	"./agent/agent-tree/table.js": 225,
	"./agent/bonusReportAgentList": 1077,
	"./agent/bonusReportAgentList.js": 1077,
	"./agent/casinoGamesReportAgentList": 1078,
	"./agent/casinoGamesReportAgentList.js": 1078,
	"./agent/comissions": 1079,
	"./agent/comissions.js": 1079,
	"./agent/comissions/autoexclusionUsers": 1080,
	"./agent/comissions/autoexclusionUsers.js": 1080,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1081,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1081,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1082,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1082,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1083,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1083,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1084,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1084,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1085,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1085,
	"./agent/comissions/betsReport/detailsReport": 1086,
	"./agent/comissions/betsReport/detailsReport.js": 1086,
	"./agent/comissions/betsReport/filterReport": 1087,
	"./agent/comissions/betsReport/filterReport.js": 1087,
	"./agent/comissions/betsReport/recordReport": 1088,
	"./agent/comissions/betsReport/recordReport.js": 1088,
	"./agent/comissions/betsReport/recordTableReport": 1089,
	"./agent/comissions/betsReport/recordTableReport.js": 1089,
	"./agent/comissions/betsReport/recordTableTransReport": 1090,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1090,
	"./agent/comissions/betsReport/recordTransReport": 1091,
	"./agent/comissions/betsReport/recordTransReport.js": 1091,
	"./agent/comissions/betsReport/tableReport": 1092,
	"./agent/comissions/betsReport/tableReport.js": 1092,
	"./agent/comissions/betsReportBetShop": 1093,
	"./agent/comissions/betsReportBetShop.js": 1093,
	"./agent/comissions/bonusReport/detailsBonusReport": 1094,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1094,
	"./agent/comissions/bonusReport/filterBonusReport": 1095,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1095,
	"./agent/comissions/bonusReport/recordBonusReport": 1096,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1096,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1097,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1097,
	"./agent/comissions/bonusReport/tableBonusReport": 1098,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1098,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1099,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1099,
	"./agent/comissions/casinoReport/filterCasinoReport": 1100,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1100,
	"./agent/comissions/casinoReport/recordCasinoReport": 1101,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1101,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1102,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1102,
	"./agent/comissions/casinoReport/tableCasinoReport": 1103,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1103,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1104,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1104,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1105,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1105,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1106,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1106,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1107,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1107,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1108,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1108,
	"./agent/comissions/comissions": 1109,
	"./agent/comissions/comissions.js": 1109,
	"./agent/comissions/comissions/table": 234,
	"./agent/comissions/comissions/table.js": 234,
	"./agent/comissions/comissionsReportBetShop": 1110,
	"./agent/comissions/comissionsReportBetShop.js": 1110,
	"./agent/comissions/comissionsReportBetShopDetail": 1111,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1111,
	"./agent/comissions/comissions_report/detailsDepositReports": 1112,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1112,
	"./agent/comissions/comissions_report/filter": 235,
	"./agent/comissions/comissions_report/filter.js": 235,
	"./agent/comissions/comissions_report/recordDepositReports": 1113,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1113,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1114,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1114,
	"./agent/comissions/comissions_report/table": 236,
	"./agent/comissions/comissions_report/table.js": 236,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1115,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1115,
	"./agent/comissions/comissions_report_detail/filter": 237,
	"./agent/comissions/comissions_report_detail/filter.js": 237,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1116,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1116,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1117,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1117,
	"./agent/comissions/comissions_report_detail/table": 238,
	"./agent/comissions/comissions_report_detail/table.js": 238,
	"./agent/comissions/expenses": 1118,
	"./agent/comissions/expenses.js": 1118,
	"./agent/comissions/expenses/filter": 1119,
	"./agent/comissions/expenses/filter.js": 1119,
	"./agent/comissions/expenses/table": 1120,
	"./agent/comissions/expenses/table.js": 1120,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1121,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1121,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1122,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1122,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1123,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1123,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1124,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1124,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1125,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1125,
	"./agent/comissions/incomes": 1126,
	"./agent/comissions/incomes.js": 1126,
	"./agent/comissions/incomes/filter": 1127,
	"./agent/comissions/incomes/filter.js": 1127,
	"./agent/comissions/incomes/table": 1128,
	"./agent/comissions/incomes/table.js": 1128,
	"./agent/comissions/productsThird": 1129,
	"./agent/comissions/productsThird.js": 1129,
	"./agent/comissions/productsThird/filter": 1130,
	"./agent/comissions/productsThird/filter.js": 1130,
	"./agent/comissions/productsThird/table": 1131,
	"./agent/comissions/productsThird/table.js": 1131,
	"./agent/comissions/promotionalCodes": 1132,
	"./agent/comissions/promotionalCodes.js": 1132,
	"./agent/comissions/promotionalCodes/filter": 1133,
	"./agent/comissions/promotionalCodes/filter.js": 1133,
	"./agent/comissions/promotionalCodes/table": 1134,
	"./agent/comissions/promotionalCodes/table.js": 1134,
	"./agent/comissions/withdrawalRequests": 1135,
	"./agent/comissions/withdrawalRequests.js": 1135,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 241,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 241,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 239,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1136,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1136,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 242,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 242,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 240,
	"./agent/configuration/changePassword": 1137,
	"./agent/configuration/changePassword.js": 1137,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1138,
	"./agent/configuration/generateToken.js": 1138,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1139,
	"./agent/configuration/qrgoogle.js": 1139,
	"./agent/configuration/securityChanges": 1140,
	"./agent/configuration/securityChanges.js": 1140,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1141,
	"./agent/configurationAgentList.js": 1141,
	"./agent/depositReportAgentList": 1142,
	"./agent/depositReportAgentList.js": 1142,
	"./agent/financescustomerAgentList": 1143,
	"./agent/financescustomerAgentList.js": 1143,
	"./agent/financial/comisiones": 1144,
	"./agent/financial/comisiones.js": 1144,
	"./agent/financial/comisiones/table": 245,
	"./agent/financial/comisiones/table.js": 245,
	"./agent/financial/informationFinancialAgentList": 1145,
	"./agent/financial/informationFinancialAgentList.js": 1145,
	"./agent/financial/withdrawalRequestsAgentList": 1146,
	"./agent/financial/withdrawalRequestsAgentList.js": 1146,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 246,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 246,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1147,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1147,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 247,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 247,
	"./agent/flujoCajaAgentList": 1148,
	"./agent/flujoCajaAgentList.js": 1148,
	"./agent/flujoCajaHijosAgentList": 1149,
	"./agent/flujoCajaHijosAgentList.js": 1149,
	"./agent/geo": 1150,
	"./agent/geo.js": 1150,
	"./agent/informationAgentList": 1151,
	"./agent/informationAgentList.js": 1151,
	"./agent/informeRed/details": 1152,
	"./agent/informeRed/details.js": 1152,
	"./agent/informeRed/filter": 254,
	"./agent/informeRed/filter.js": 254,
	"./agent/informeRed/record": 1153,
	"./agent/informeRed/record.js": 1153,
	"./agent/informeRed/recordTable": 1154,
	"./agent/informeRed/recordTable.js": 1154,
	"./agent/informeRed/table": 255,
	"./agent/informeRed/table.js": 255,
	"./agent/money": 1155,
	"./agent/money.js": 1155,
	"./agent/paymenthistory": 1156,
	"./agent/paymenthistory.js": 1156,
	"./agent/positions": 1157,
	"./agent/positions.js": 1157,
	"./agent/reports/autoexclusionUsers": 1158,
	"./agent/reports/autoexclusionUsers.js": 1158,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1159,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1159,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1160,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1160,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1161,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1161,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1162,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1162,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1163,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1163,
	"./agent/reports/balanceTransactionReport": 1164,
	"./agent/reports/balanceTransactionReport.js": 1164,
	"./agent/reports/balanceTransactionReport/filter": 256,
	"./agent/reports/balanceTransactionReport/filter.js": 256,
	"./agent/reports/balanceTransactionReport/table": 257,
	"./agent/reports/balanceTransactionReport/table.js": 257,
	"./agent/reports/betsReport/detailsReport": 1165,
	"./agent/reports/betsReport/detailsReport.js": 1165,
	"./agent/reports/betsReport/filterReport": 258,
	"./agent/reports/betsReport/filterReport.js": 258,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1166,
	"./agent/reports/betsReport/recordTableReport.js": 1166,
	"./agent/reports/betsReport/recordTableTransReport": 1167,
	"./agent/reports/betsReport/recordTableTransReport.js": 1167,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 259,
	"./agent/reports/betsReport/tableReport.js": 259,
	"./agent/reports/betsReportAgentList": 1168,
	"./agent/reports/betsReportAgentList.js": 1168,
	"./agent/reports/bonusReport/detailsBonusReport": 228,
	"./agent/reports/bonusReport/detailsBonusReport.js": 228,
	"./agent/reports/bonusReport/filterBonusReport": 226,
	"./agent/reports/bonusReport/filterBonusReport.js": 226,
	"./agent/reports/bonusReport/recordBonusReport": 229,
	"./agent/reports/bonusReport/recordBonusReport.js": 229,
	"./agent/reports/bonusReport/recordTableBonusReport": 1169,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1169,
	"./agent/reports/bonusReport/tableBonusReport": 227,
	"./agent/reports/bonusReport/tableBonusReport.js": 227,
	"./agent/reports/casinoReport/detailsCasinoReport": 232,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 232,
	"./agent/reports/casinoReport/filterCasinoReport": 230,
	"./agent/reports/casinoReport/filterCasinoReport.js": 230,
	"./agent/reports/casinoReport/recordCasinoReport": 233,
	"./agent/reports/casinoReport/recordCasinoReport.js": 233,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1170,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1170,
	"./agent/reports/casinoReport/tableCasinoReport": 231,
	"./agent/reports/casinoReport/tableCasinoReport.js": 231,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1171,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1171,
	"./agent/reports/casinoReport2/filterCasinoReport": 1172,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1172,
	"./agent/reports/casinoReport2/recordCasinoReport": 1173,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1173,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1174,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1174,
	"./agent/reports/casinoReport2/tableCasinoReport": 1175,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1175,
	"./agent/reports/deposit_report/detailsDepositReports": 1176,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1176,
	"./agent/reports/deposit_report/filterDepositReports": 243,
	"./agent/reports/deposit_report/filterDepositReports.js": 243,
	"./agent/reports/deposit_report/recordDepositReports": 1177,
	"./agent/reports/deposit_report/recordDepositReports.js": 1177,
	"./agent/reports/deposit_report/recordTableDepositReports": 1178,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1178,
	"./agent/reports/deposit_report/tableDepositReports": 244,
	"./agent/reports/deposit_report/tableDepositReports.js": 244,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1179,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1179,
	"./agent/reports/flujocaja/filterFlujoCaja": 248,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 248,
	"./agent/reports/flujocaja/recordFlujoCaja": 1180,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1180,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1181,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1181,
	"./agent/reports/flujocaja/tableFlujoCaja": 249,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 249,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 252,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 253,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1182,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1182,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 251,
	"./agent/reports/managementReport": 1183,
	"./agent/reports/managementReport.js": 1183,
	"./agent/reports/managementReport/filterReports": 260,
	"./agent/reports/managementReport/filterReports.js": 260,
	"./agent/reports/managementReport/tableReports": 261,
	"./agent/reports/managementReport/tableReports.js": 261,
	"./agent/reports/marketing/filterReports": 262,
	"./agent/reports/marketing/filterReports.js": 262,
	"./agent/reports/marketing/tableReports": 263,
	"./agent/reports/marketing/tableReports.js": 263,
	"./agent/reports/marketingReport": 1184,
	"./agent/reports/marketingReport.js": 1184,
	"./agent/reports/promotionalCodes": 1185,
	"./agent/reports/promotionalCodes.js": 1185,
	"./agent/reports/promotionalCodes/filter": 264,
	"./agent/reports/promotionalCodes/filter.js": 264,
	"./agent/reports/promotionalCodes/table": 265,
	"./agent/reports/promotionalCodes/table.js": 265,
	"./agent/reports/quotaRetractionReport/filter": 266,
	"./agent/reports/quotaRetractionReport/filter.js": 266,
	"./agent/reports/quotaRetractionReport/table": 267,
	"./agent/reports/quotaRetractionReport/table.js": 267,
	"./agent/reports/quotaRetractionReportAgent": 1186,
	"./agent/reports/quotaRetractionReportAgent.js": 1186,
	"./agent/reports/transfersReport/filter": 268,
	"./agent/reports/transfersReport/filter.js": 268,
	"./agent/reports/transfersReport/table": 269,
	"./agent/reports/transfersReport/table.js": 269,
	"./agent/reports/trasnfersReport": 1187,
	"./agent/reports/trasnfersReport.js": 1187,
	"./agent/reports/userAfilliatesReport": 1188,
	"./agent/reports/userAfilliatesReport.js": 1188,
	"./agent/reports/user_affiliates/detailsReports": 272,
	"./agent/reports/user_affiliates/detailsReports.js": 272,
	"./agent/reports/user_affiliates/filterReports": 270,
	"./agent/reports/user_affiliates/filterReports.js": 270,
	"./agent/reports/user_affiliates/recordReports": 273,
	"./agent/reports/user_affiliates/recordReports.js": 273,
	"./agent/reports/user_affiliates/recordTableReports": 1189,
	"./agent/reports/user_affiliates/recordTableReports.js": 1189,
	"./agent/reports/user_affiliates/tableReports": 271,
	"./agent/reports/user_affiliates/tableReports.js": 271,
	"./agent/reportscustomerAgentList": 1190,
	"./agent/reportscustomerAgentList.js": 1190,
	"./agent/requestsAgent": 1191,
	"./agent/requestsAgent.js": 1191,
	"./agent/requestsAgent/filter": 274,
	"./agent/requestsAgent/filter.js": 274,
	"./agent/requestsAgent/table": 275,
	"./agent/requestsAgent/table.js": 275,
	"./agent/requirementsAgent": 1192,
	"./agent/requirementsAgent.js": 1192,
	"./agent/requirementsAgent/details": 278,
	"./agent/requirementsAgent/details.js": 278,
	"./agent/requirementsAgent/detailsFilter": 280,
	"./agent/requirementsAgent/detailsFilter.js": 280,
	"./agent/requirementsAgent/detailsTable": 279,
	"./agent/requirementsAgent/detailsTable.js": 279,
	"./agent/requirementsAgent/filter": 276,
	"./agent/requirementsAgent/filter.js": 276,
	"./agent/requirementsAgent/table": 277,
	"./agent/requirementsAgent/table.js": 277,
	"./agent/statistics/age": 281,
	"./agent/statistics/age.js": 281,
	"./agent/statistics/marketing": 282,
	"./agent/statistics/marketing.js": 282,
	"./agent/statistics/marketingvsregistros": 283,
	"./agent/statistics/marketingvsregistros.js": 283,
	"./agent/statistics/money": 284,
	"./agent/statistics/money.js": 284,
	"./agent/statisticsAgentList": 1193,
	"./agent/statisticsAgentList.js": 1193,
	"./agent/tags": 1194,
	"./agent/tags.js": 1194,
	"./agentList": 1195,
	"./agentList.js": 1195,
	"./agentListManagement": 1196,
	"./agentListManagement.js": 1196,
	"./agentRetraction": 1197,
	"./agentRetraction.js": 1197,
	"./agentTransfers": 1198,
	"./agentTransfers.js": 1198,
	"./agentsInform": 1199,
	"./agentsInform.js": 1199,
	"./agentsTree": 1200,
	"./agentsTree.js": 1200,
	"./alltactions": 285,
	"./alltactions.js": 285,
	"./approvalLogs": 1201,
	"./approvalLogs.js": 1201,
	"./approvalLogs2": 1202,
	"./approvalLogs2.js": 1202,
	"./approvalLogsBetShop": 1203,
	"./approvalLogsBetShop.js": 1203,
	"./assignmentQuotaMade": 1204,
	"./assignmentQuotaMade.js": 1204,
	"./assignmentQuotaR": 1205,
	"./assignmentQuotaR.js": 1205,
	"./autoexclusionUsers": 1206,
	"./autoexclusionUsers.js": 1206,
	"./balanceAdjustments": 1207,
	"./balanceAdjustments.js": 1207,
	"./balanceHistory": 1208,
	"./balanceHistory.js": 1208,
	"./balanceHistory2": 1209,
	"./balanceHistory2.js": 1209,
	"./balanceHistoryAdminUser": 1210,
	"./balanceHistoryAdminUser.js": 1210,
	"./balanceHistoryBetShop": 1211,
	"./balanceHistoryBetShop.js": 1211,
	"./balanceHistoryBetShop2": 1212,
	"./balanceHistoryBetShop2.js": 1212,
	"./balanceHistoryForAgent": 1213,
	"./balanceHistoryForAgent.js": 1213,
	"./balanceHistoryForBetShop": 1214,
	"./balanceHistoryForBetShop.js": 1214,
	"./balanceHistoryMachine": 1215,
	"./balanceHistoryMachine.js": 1215,
	"./balanceUsers": 1216,
	"./balanceUsers.js": 1216,
	"./bankAccounts": 1217,
	"./bankAccounts.js": 1217,
	"./banks": 1218,
	"./banks.js": 1218,
	"./betShop": 1219,
	"./betShop.js": 1219,
	"./betShopCompetence": 1220,
	"./betShopCompetence.js": 1220,
	"./betShopManagement": 1221,
	"./betShopManagement.js": 1221,
	"./betShopManagement/addInformationBetShop": 1222,
	"./betShopManagement/addInformationBetShop.js": 1222,
	"./betShopManagement/age": 1223,
	"./betShopManagement/age.js": 1223,
	"./betShopManagement/betShop/detailsBetShop": 1009,
	"./betShopManagement/betShop/detailsBetShop.js": 1009,
	"./betShopManagement/betShop/filterBetShop": 326,
	"./betShopManagement/betShop/filterBetShop.js": 326,
	"./betShopManagement/betShop/recordBetShop": 328,
	"./betShopManagement/betShop/recordBetShop.js": 328,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 327,
	"./betShopManagement/betShop/tableBetShop.js": 327,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1224,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1224,
	"./betShopManagement/betShopCompetence/filterBetShop": 329,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 329,
	"./betShopManagement/betShopCompetence/recordBetShop": 1225,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1225,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1226,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1226,
	"./betShopManagement/betShopCompetence/tableBetShop": 330,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 330,
	"./betShopManagement/bonusReportBetShop": 1227,
	"./betShopManagement/bonusReportBetShop.js": 1227,
	"./betShopManagement/cashier/betShopAdvertising": 335,
	"./betShopManagement/cashier/betShopAdvertising.js": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 337,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 337,
	"./betShopManagement/cashier/betShopCashier": 1228,
	"./betShopManagement/cashier/betShopCashier.js": 1228,
	"./betShopManagement/cashier/betShopComissions": 1010,
	"./betShopManagement/cashier/betShopComissions.js": 1010,
	"./betShopManagement/cashier/filterCashier": 340,
	"./betShopManagement/cashier/filterCashier.js": 340,
	"./betShopManagement/cashier/tableAdvertising": 336,
	"./betShopManagement/cashier/tableAdvertising.js": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier": 338,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 338,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 339,
	"./betShopManagement/cashier/tableComissions.js": 339,
	"./betShopManagement/casinoGamesReportBetShop": 1229,
	"./betShopManagement/casinoGamesReportBetShop.js": 1229,
	"./betShopManagement/comissions": 1230,
	"./betShopManagement/comissions.js": 1230,
	"./betShopManagement/comissions/autoexclusionUsers": 1231,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1231,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1232,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1232,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1233,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1233,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1234,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1234,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1235,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1235,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1236,
	"./betShopManagement/comissions/betsReport/detailsReport": 1237,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1237,
	"./betShopManagement/comissions/betsReport/filterReport": 1238,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1238,
	"./betShopManagement/comissions/betsReport/recordReport": 1239,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1239,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1240,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1240,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1241,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1241,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1242,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1242,
	"./betShopManagement/comissions/betsReport/tableReport": 1243,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1243,
	"./betShopManagement/comissions/betsReportBetShop": 1244,
	"./betShopManagement/comissions/betsReportBetShop.js": 1244,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1245,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1245,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1246,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1246,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1247,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1247,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1248,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1248,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1249,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1249,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1250,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1250,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1251,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1251,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1252,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1252,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1253,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1253,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1254,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1254,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1255,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1255,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1256,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1256,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1257,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1257,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1258,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1258,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1259,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1259,
	"./betShopManagement/comissions/comissions": 1260,
	"./betShopManagement/comissions/comissions.js": 1260,
	"./betShopManagement/comissions/comissions/table": 345,
	"./betShopManagement/comissions/comissions/table.js": 345,
	"./betShopManagement/comissions/comissionsReportBetShop": 1261,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1261,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1262,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1262,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1263,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1263,
	"./betShopManagement/comissions/comissions_report/filter": 346,
	"./betShopManagement/comissions/comissions_report/filter.js": 346,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1264,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1264,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1265,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1265,
	"./betShopManagement/comissions/comissions_report/table": 347,
	"./betShopManagement/comissions/comissions_report/table.js": 347,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1266,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1266,
	"./betShopManagement/comissions/comissions_report_detail/filter": 348,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 348,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1267,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1267,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1268,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1268,
	"./betShopManagement/comissions/comissions_report_detail/table": 349,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 349,
	"./betShopManagement/comissions/expenses": 1269,
	"./betShopManagement/comissions/expenses.js": 1269,
	"./betShopManagement/comissions/expenses/filter": 1270,
	"./betShopManagement/comissions/expenses/filter.js": 1270,
	"./betShopManagement/comissions/expenses/table": 1271,
	"./betShopManagement/comissions/expenses/table.js": 1271,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1272,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1272,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1273,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1273,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1274,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1274,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1275,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1275,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1276,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1276,
	"./betShopManagement/comissions/incomes": 1277,
	"./betShopManagement/comissions/incomes.js": 1277,
	"./betShopManagement/comissions/incomes/filter": 1278,
	"./betShopManagement/comissions/incomes/filter.js": 1278,
	"./betShopManagement/comissions/incomes/table": 1279,
	"./betShopManagement/comissions/incomes/table.js": 1279,
	"./betShopManagement/comissions/productsThird": 1280,
	"./betShopManagement/comissions/productsThird.js": 1280,
	"./betShopManagement/comissions/productsThird/filter": 1281,
	"./betShopManagement/comissions/productsThird/filter.js": 1281,
	"./betShopManagement/comissions/productsThird/table": 1282,
	"./betShopManagement/comissions/productsThird/table.js": 1282,
	"./betShopManagement/comissions/promotionalCodes": 1283,
	"./betShopManagement/comissions/promotionalCodes.js": 1283,
	"./betShopManagement/comissions/promotionalCodes/filter": 1284,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1284,
	"./betShopManagement/comissions/promotionalCodes/table": 1285,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1285,
	"./betShopManagement/comissions/withdrawalRequests": 1286,
	"./betShopManagement/comissions/withdrawalRequests.js": 1286,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 352,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 352,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1287,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1287,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 353,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 353,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 351,
	"./betShopManagement/configuration/changePassword": 1288,
	"./betShopManagement/configuration/changePassword.js": 1288,
	"./betShopManagement/configuration/changePassword/changePasswordView": 354,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 354,
	"./betShopManagement/configuration/configNtc": 1289,
	"./betShopManagement/configuration/configNtc.js": 1289,
	"./betShopManagement/configuration/configNtc/configNtcView": 355,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 355,
	"./betShopManagement/configuration/generateToken": 1290,
	"./betShopManagement/configuration/generateToken.js": 1290,
	"./betShopManagement/configuration/generateToken/filter": 356,
	"./betShopManagement/configuration/generateToken/filter.js": 356,
	"./betShopManagement/configuration/generateToken/table": 357,
	"./betShopManagement/configuration/generateToken/table.js": 357,
	"./betShopManagement/configuration/qrgoogle": 1291,
	"./betShopManagement/configuration/qrgoogle.js": 1291,
	"./betShopManagement/configuration/securityChanges": 1292,
	"./betShopManagement/configuration/securityChanges.js": 1292,
	"./betShopManagement/configuration/securityChanges/filter": 1011,
	"./betShopManagement/configuration/securityChanges/filter.js": 1011,
	"./betShopManagement/configuration/securityChanges/table": 358,
	"./betShopManagement/configuration/securityChanges/table.js": 358,
	"./betShopManagement/configurationBetShop": 1293,
	"./betShopManagement/configurationBetShop.js": 1293,
	"./betShopManagement/depositReportBetShop": 1294,
	"./betShopManagement/depositReportBetShop.js": 1294,
	"./betShopManagement/financescustomerBetShop": 1295,
	"./betShopManagement/financescustomerBetShop.js": 1295,
	"./betShopManagement/financial/bankAccountsBetShop": 1296,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1296,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1297,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1297,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 361,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 361,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1298,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1298,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1299,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1299,
	"./betShopManagement/financial/bankAccountsBetShop/table": 362,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 362,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1300,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1300,
	"./betShopManagement/financial/informationFinancialBetShop": 1301,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1301,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1302,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1302,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 364,
	"./betShopManagement/flujoCajaBetShop": 1303,
	"./betShopManagement/flujoCajaBetShop.js": 1303,
	"./betShopManagement/geo": 1304,
	"./betShopManagement/geo.js": 1304,
	"./betShopManagement/informationBetShop": 1305,
	"./betShopManagement/informationBetShop.js": 1305,
	"./betShopManagement/money": 1306,
	"./betShopManagement/money.js": 1306,
	"./betShopManagement/paymenthistory": 1307,
	"./betShopManagement/paymenthistory.js": 1307,
	"./betShopManagement/positions": 1308,
	"./betShopManagement/positions.js": 1308,
	"./betShopManagement/reports/autoexclusionUsers": 1309,
	"./betShopManagement/reports/autoexclusionUsers.js": 1309,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1310,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1310,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1311,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1311,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1312,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1312,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1313,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1313,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1314,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1314,
	"./betShopManagement/reports/balanceTransactionReport": 1315,
	"./betShopManagement/reports/balanceTransactionReport.js": 1315,
	"./betShopManagement/reports/balanceTransactionReport/filter": 368,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 368,
	"./betShopManagement/reports/balanceTransactionReport/table": 369,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 369,
	"./betShopManagement/reports/betsReport/detailsReport": 1316,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1316,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1317,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1317,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1318,
	"./betShopManagement/reports/betsReportBetShop.js": 1318,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 333,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 333,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 334,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 334,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1319,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1319,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 332,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 332,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1320,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1320,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1321,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1321,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1322,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1322,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1323,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1323,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1324,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1324,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1325,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1325,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1012,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1012,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 359,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 359,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1326,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1326,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 360,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 360,
	"./betShopManagement/reports/expenses": 1327,
	"./betShopManagement/reports/expenses.js": 1327,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1328,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1328,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 366,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 366,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1329,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1329,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1330,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1330,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 367,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 367,
	"./betShopManagement/reports/historyMovement": 1331,
	"./betShopManagement/reports/historyMovement.js": 1331,
	"./betShopManagement/reports/historyMovement/filter": 370,
	"./betShopManagement/reports/historyMovement/filter.js": 370,
	"./betShopManagement/reports/historyMovement/table": 371,
	"./betShopManagement/reports/historyMovement/table.js": 371,
	"./betShopManagement/reports/incomes": 1332,
	"./betShopManagement/reports/incomes.js": 1332,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1333,
	"./betShopManagement/reports/productsThird.js": 1333,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1334,
	"./betShopManagement/reports/promotionalCodes.js": 1334,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1335,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1335,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 373,
	"./betShopManagement/reportscustomerBetShop": 1336,
	"./betShopManagement/reportscustomerBetShop.js": 1336,
	"./betShopManagement/statisticsBetShop": 1337,
	"./betShopManagement/statisticsBetShop.js": 1337,
	"./betShopManagement/tags": 1338,
	"./betShopManagement/tags.js": 1338,
	"./betsHistory": 1339,
	"./betsHistory.js": 1339,
	"./betsHistory2": 1340,
	"./betsHistory2.js": 1340,
	"./betsReport": 1341,
	"./betsReport.js": 1341,
	"./betsReportBetShop": 1342,
	"./betsReportBetShop.js": 1342,
	"./betsReportSecond": 1343,
	"./betsReportSecond.js": 1343,
	"./betsSport": 1344,
	"./betsSport.js": 1344,
	"./betsSportLive": 1345,
	"./betsSportLive.js": 1345,
	"./betsVirtual": 1346,
	"./betsVirtual.js": 1346,
	"./betting": 1347,
	"./betting.js": 1347,
	"./bettingVirtual": 1348,
	"./bettingVirtual.js": 1348,
	"./blockchains": 1349,
	"./blockchains.js": 1349,
	"./bonusReport": 1350,
	"./bonusReport.js": 1350,
	"./bonusReport2": 1351,
	"./bonusReport2.js": 1351,
	"./cash/bankAccounts/filter": 321,
	"./cash/bankAccounts/filter.js": 321,
	"./cash/bankAccounts/table": 322,
	"./cash/bankAccounts/table.js": 322,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1352,
	"./cash/bets/betHistory2.js": 1352,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 378,
	"./cash/bets/sportLive.js": 378,
	"./cash/bets/sportVirtual": 379,
	"./cash/bets/sportVirtual.js": 379,
	"./cash/closeBox-edit/creditCards": 386,
	"./cash/closeBox-edit/creditCards.js": 386,
	"./cash/closeBox-edit/otherExpenses": 387,
	"./cash/closeBox-edit/otherExpenses.js": 387,
	"./cash/closeBox-edit/otherIncome": 388,
	"./cash/closeBox-edit/otherIncome.js": 388,
	"./cash/closeBox-edit/products": 389,
	"./cash/closeBox-edit/products.js": 389,
	"./cash/closeBox-edit/total": 390,
	"./cash/closeBox-edit/total.js": 390,
	"./cash/closeBox-old/otherExpenses": 1353,
	"./cash/closeBox-old/otherExpenses.js": 1353,
	"./cash/closeBox-old/otherIncome": 1354,
	"./cash/closeBox-old/otherIncome.js": 1354,
	"./cash/closeBox-old/products": 1355,
	"./cash/closeBox-old/products.js": 1355,
	"./cash/closeBox-old/total": 1356,
	"./cash/closeBox-old/total.js": 1356,
	"./cash/closeBox/creditCards": 391,
	"./cash/closeBox/creditCards.js": 391,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 392,
	"./cash/flujocaja/detailsFlujoCaja.js": 392,
	"./cash/flujocaja/filterFlujoCaja": 393,
	"./cash/flujocaja/filterFlujoCaja.js": 393,
	"./cash/flujocaja/recordFlujoCaja": 394,
	"./cash/flujocaja/recordFlujoCaja.js": 394,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 395,
	"./cash/flujocaja/tableFlujoCaja.js": 395,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 396,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 396,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 397,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 397,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1013,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1013,
	"./cash/pagopremio/PagoPremio": 398,
	"./cash/pagopremio/PagoPremio.js": 398,
	"./cash/pagopremio/detailsPagoPremio": 399,
	"./cash/pagopremio/detailsPagoPremio.js": 399,
	"./cash/pagopremio/filterPagoPremio": 400,
	"./cash/pagopremio/filterPagoPremio.js": 400,
	"./cash/pagopremio/recordPagoPremio": 401,
	"./cash/pagopremio/recordPagoPremio.js": 401,
	"./cash/pagopremio/recordTablePagoPremio": 1357,
	"./cash/pagopremio/recordTablePagoPremio.js": 1357,
	"./cash/pagopremio/tablePagoPremio": 402,
	"./cash/pagopremio/tablePagoPremio.js": 402,
	"./cash/pagopremiovirtuales/PagoPremio": 403,
	"./cash/pagopremiovirtuales/PagoPremio.js": 403,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 404,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 404,
	"./cash/pagopremiovirtuales/filterPagoPremio": 405,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 405,
	"./cash/pagopremiovirtuales/recordPagoPremio": 406,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 406,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1358,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1358,
	"./cash/pagopremiovirtuales/tablePagoPremio": 407,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 407,
	"./cash/payPrizesLoyalty/PagoPremio": 408,
	"./cash/payPrizesLoyalty/PagoPremio.js": 408,
	"./cash/payPrizesLoyalty/filterPagoPremio": 409,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 409,
	"./cash/recargacredito/RecargaCredito": 410,
	"./cash/recargacredito/RecargaCredito.js": 410,
	"./cash/recargacredito/filterRecargaCredito": 411,
	"./cash/recargacredito/filterRecargaCredito.js": 411,
	"./cash/recargacreditoAgent/RecargaCredito": 412,
	"./cash/recargacreditoAgent/RecargaCredito.js": 412,
	"./cash/recargacreditoAgent/filterRecargaCredito": 413,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 413,
	"./cash/withdrawal/filter": 414,
	"./cash/withdrawal/filter.js": 414,
	"./cash/withdrawal/table": 415,
	"./cash/withdrawal/table.js": 415,
	"./cashiers": 1359,
	"./cashiers.js": 1359,
	"./casinoGamesReport": 1360,
	"./casinoGamesReport.js": 1360,
	"./casinoGamesReport2": 1361,
	"./casinoGamesReport2.js": 1361,
	"./categories": 1362,
	"./categories.js": 1362,
	"./categoriesProducts": 1363,
	"./categoriesProducts.js": 1363,
	"./closeBox": 1364,
	"./closeBox-old": 1365,
	"./closeBox-old.js": 1365,
	"./closeBox.js": 1364,
	"./closeBoxEdit": 1366,
	"./closeBoxEdit.js": 1366,
	"./comissionsReport": 1367,
	"./comissionsReport.js": 1367,
	"./comissionsReport2": 1368,
	"./comissionsReport2.js": 1368,
	"./commisionsPay": 1369,
	"./commisionsPay.js": 1369,
	"./competitors/competitors": 1370,
	"./competitors/competitors.js": 1370,
	"./competitors/filter": 432,
	"./competitors/filter.js": 432,
	"./competitors/table": 433,
	"./competitors/table.js": 433,
	"./consolidatedIncome": 1371,
	"./consolidatedIncome.js": 1371,
	"./consolidatedIncomeOwner": 1372,
	"./consolidatedIncomeOwner.js": 1372,
	"./consolidatedIncomeOwner2": 1373,
	"./consolidatedIncomeOwner2.js": 1373,
	"./contingency": 1374,
	"./contingency.js": 1374,
	"./countries": 1375,
	"./countries.js": 1375,
	"./coupons": 1376,
	"./coupons.js": 1376,
	"./couponsReport": 1377,
	"./couponsReport.js": 1377,
	"./cryptoBlockchain": 1378,
	"./cryptoBlockchain.js": 1378,
	"./cryptos": 1379,
	"./cryptos.js": 1379,
	"./customReport": 1380,
	"./customReport.js": 1380,
	"./customers": 1381,
	"./customers.js": 1381,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1382,
	"./customers/bonusReport.js": 1382,
	"./customers/bonusReport2": 1383,
	"./customers/bonusReport2.js": 1383,
	"./customers/casinoGamesReport": 1384,
	"./customers/casinoGamesReport.js": 1384,
	"./customers/configuration": 1385,
	"./customers/configuration.js": 1385,
	"./customers/configuration/changePassword": 1386,
	"./customers/configuration/changePassword.js": 1386,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1387,
	"./customers/configuration/generateToken.js": 1387,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1388,
	"./customers/configuration/limitChanges.js": 1388,
	"./customers/configuration/securityChanges": 1389,
	"./customers/configuration/securityChanges.js": 1389,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1390,
	"./customers/configuration/securityChanges2.js": 1390,
	"./customers/depositReport": 1391,
	"./customers/depositReport.js": 1391,
	"./customers/financescustomer": 1392,
	"./customers/financescustomer.js": 1392,
	"./customers/financial/bankAccounts": 1393,
	"./customers/financial/bankAccounts.js": 1393,
	"./customers/financial/bankAccounts/details": 1018,
	"./customers/financial/bankAccounts/details.js": 1018,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 455,
	"./customers/financial/bankAccounts/record.js": 455,
	"./customers/financial/bankAccounts/recordTable": 1394,
	"./customers/financial/bankAccounts/recordTable.js": 1394,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1395,
	"./customers/financial/bankAccounts/tablePopup.js": 1395,
	"./customers/financial/informationFinancial": 1396,
	"./customers/financial/informationFinancial.js": 1396,
	"./customers/financial/withdrawalRequests": 1397,
	"./customers/financial/withdrawalRequests.js": 1397,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1398,
	"./customers/information.js": 1398,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 456,
	"./customers/paymenthistory.js": 456,
	"./customers/players/filter": 457,
	"./customers/players/filter.js": 457,
	"./customers/players/table": 458,
	"./customers/players/table.js": 458,
	"./customers/players2/filter": 459,
	"./customers/players2/filter.js": 459,
	"./customers/players2/table": 460,
	"./customers/players2/table.js": 460,
	"./customers/playersAggregator/filter": 461,
	"./customers/playersAggregator/filter.js": 461,
	"./customers/playersAggregator/table": 462,
	"./customers/playersAggregator/table.js": 462,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1399,
	"./customers/referralsReport.js": 1399,
	"./customers/reports/autoexclusionUsers": 1400,
	"./customers/reports/autoexclusionUsers.js": 1400,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1401,
	"./customers/reports/balanceAdjustments.js": 1401,
	"./customers/reports/balanceAdjustments/filter": 465,
	"./customers/reports/balanceAdjustments/filter.js": 465,
	"./customers/reports/balanceAdjustments/table": 466,
	"./customers/reports/balanceAdjustments/table.js": 466,
	"./customers/reports/balanceHistory": 1402,
	"./customers/reports/balanceHistory.js": 1402,
	"./customers/reports/balanceHistory/filter": 467,
	"./customers/reports/balanceHistory/filter.js": 467,
	"./customers/reports/balanceHistory/table": 468,
	"./customers/reports/balanceHistory/table.js": 468,
	"./customers/reports/betsReport": 1403,
	"./customers/reports/betsReport.js": 1403,
	"./customers/reports/betsReport/detailsReport": 1404,
	"./customers/reports/betsReport/detailsReport.js": 1404,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 453,
	"./customers/reports/bonusReport2/filterBonusReport.js": 453,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1405,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1405,
	"./customers/reports/bonusReport2/tableBonusReport": 454,
	"./customers/reports/bonusReport2/tableBonusReport.js": 454,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1406,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1406,
	"./customers/reports/casinoReport2/filterCasinoReport": 1407,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1407,
	"./customers/reports/casinoReport2/recordCasinoReport": 1408,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1408,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1409,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1409,
	"./customers/reports/casinoReport2/tableCasinoReport": 1410,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1410,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1411,
	"./customers/reports/historyMovement.js": 1411,
	"./customers/reports/historyMovement/filter": 469,
	"./customers/reports/historyMovement/filter.js": 469,
	"./customers/reports/historyMovement/table": 470,
	"./customers/reports/historyMovement/table.js": 470,
	"./customers/reports/historyPoints": 1412,
	"./customers/reports/historyPoints.js": 1412,
	"./customers/reports/historyPoints/filter": 471,
	"./customers/reports/historyPoints/filter.js": 471,
	"./customers/reports/historyPoints/table": 472,
	"./customers/reports/historyPoints/table.js": 472,
	"./customers/reports/logsUser": 1413,
	"./customers/reports/logsUser.js": 1413,
	"./customers/reports/logsUser/filter": 473,
	"./customers/reports/logsUser/filter.js": 473,
	"./customers/reports/logsUser/table": 474,
	"./customers/reports/logsUser/table.js": 474,
	"./customers/reports/loyaltyLevelChangeHistory": 1019,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1019,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 475,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 475,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 476,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 476,
	"./customers/reports/notesUser": 1414,
	"./customers/reports/notesUser.js": 1414,
	"./customers/reports/notesUser/filter": 477,
	"./customers/reports/notesUser/filter.js": 477,
	"./customers/reports/notesUser/table": 478,
	"./customers/reports/notesUser/table.js": 478,
	"./customers/reports/playerPrizesLoyalty": 1415,
	"./customers/reports/playerPrizesLoyalty.js": 1415,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 479,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 479,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 480,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 480,
	"./customers/reports/playerRoulette": 1416,
	"./customers/reports/playerRoulette.js": 1416,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 481,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 481,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 482,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 482,
	"./customers/reports/qualifyingPointsRecord": 1417,
	"./customers/reports/qualifyingPointsRecord.js": 1417,
	"./customers/reports/qualifyingPointsRecordReport/filter": 483,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 483,
	"./customers/reports/qualifyingPointsRecordReport/table": 484,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 484,
	"./customers/reports/referralsReport/filterReferralsReports": 463,
	"./customers/reports/referralsReport/filterReferralsReports.js": 463,
	"./customers/reports/referralsReport/recordReferralsReports": 1418,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1418,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1419,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1419,
	"./customers/reports/referralsReport/tableReferralsReports": 464,
	"./customers/reports/referralsReport/tableReferralsReports.js": 464,
	"./customers/reports/registeredDocument": 1420,
	"./customers/reports/registeredDocument.js": 1420,
	"./customers/reports/registeredDocuments/filter": 485,
	"./customers/reports/registeredDocuments/filter.js": 485,
	"./customers/reports/registeredDocuments/table": 486,
	"./customers/reports/registeredDocuments/table.js": 486,
	"./customers/reports/sessionsReport": 1421,
	"./customers/reports/sessionsReport.js": 1421,
	"./customers/reports/sessionsReport/detailsSessionsReport": 489,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 489,
	"./customers/reports/sessionsReport/filterSessionsReport": 487,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 487,
	"./customers/reports/sessionsReport/recordSessionsReport": 1020,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1020,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1021,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1021,
	"./customers/reports/sessionsReport/tableSessionsReport": 488,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 488,
	"./customers/reports/sessionsReport2": 1422,
	"./customers/reports/sessionsReport2.js": 1422,
	"./customers/reports/sessionsReport2/filter": 490,
	"./customers/reports/sessionsReport2/filter.js": 490,
	"./customers/reports/sessionsReport2/table": 491,
	"./customers/reports/sessionsReport2/table.js": 491,
	"./customers/reports/walletsReport": 1423,
	"./customers/reports/walletsReport.js": 1423,
	"./customers/reports/walletsReport/filter": 492,
	"./customers/reports/walletsReport/filter.js": 492,
	"./customers/reports/walletsReport/table": 493,
	"./customers/reports/walletsReport/table.js": 493,
	"./customers/reportscustomer": 1424,
	"./customers/reportscustomer.js": 1424,
	"./customers/statistics": 1425,
	"./customers/statistics.js": 1425,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1426,
	"./customersAggregator.js": 1426,
	"./customersAggregator/age": 1427,
	"./customersAggregator/age.js": 1427,
	"./customersAggregator/bonusReport": 1428,
	"./customersAggregator/bonusReport.js": 1428,
	"./customersAggregator/casinoGamesReport": 1429,
	"./customersAggregator/casinoGamesReport.js": 1429,
	"./customersAggregator/configuration": 1430,
	"./customersAggregator/configuration.js": 1430,
	"./customersAggregator/configuration/changePassword": 1431,
	"./customersAggregator/configuration/changePassword.js": 1431,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1432,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1432,
	"./customersAggregator/configuration/generateToken": 1433,
	"./customersAggregator/configuration/generateToken.js": 1433,
	"./customersAggregator/configuration/generateToken/filter": 1434,
	"./customersAggregator/configuration/generateToken/filter.js": 1434,
	"./customersAggregator/configuration/generateToken/table": 1435,
	"./customersAggregator/configuration/generateToken/table.js": 1435,
	"./customersAggregator/configuration/securityChanges": 1436,
	"./customersAggregator/configuration/securityChanges.js": 1436,
	"./customersAggregator/configuration/securityChanges/filter": 1437,
	"./customersAggregator/configuration/securityChanges/filter.js": 1437,
	"./customersAggregator/configuration/securityChanges/table": 1438,
	"./customersAggregator/configuration/securityChanges/table.js": 1438,
	"./customersAggregator/depositReport": 1439,
	"./customersAggregator/depositReport.js": 1439,
	"./customersAggregator/financescustomer": 1440,
	"./customersAggregator/financescustomer.js": 1440,
	"./customersAggregator/financial/bankAccounts": 1441,
	"./customersAggregator/financial/bankAccounts.js": 1441,
	"./customersAggregator/financial/bankAccounts/details": 1442,
	"./customersAggregator/financial/bankAccounts/details.js": 1442,
	"./customersAggregator/financial/bankAccounts/filter": 1443,
	"./customersAggregator/financial/bankAccounts/filter.js": 1443,
	"./customersAggregator/financial/bankAccounts/record": 1444,
	"./customersAggregator/financial/bankAccounts/record.js": 1444,
	"./customersAggregator/financial/bankAccounts/recordTable": 1445,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1445,
	"./customersAggregator/financial/bankAccounts/table": 1446,
	"./customersAggregator/financial/bankAccounts/table.js": 1446,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1447,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1447,
	"./customersAggregator/financial/informationFinancial": 1448,
	"./customersAggregator/financial/informationFinancial.js": 1448,
	"./customersAggregator/financial/withdrawalRequests": 1449,
	"./customersAggregator/financial/withdrawalRequests.js": 1449,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1450,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1450,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1451,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1451,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1452,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1452,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1453,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1453,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1454,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1454,
	"./customersAggregator/geo": 1455,
	"./customersAggregator/geo.js": 1455,
	"./customersAggregator/information": 1456,
	"./customersAggregator/information.js": 1456,
	"./customersAggregator/money": 1457,
	"./customersAggregator/money.js": 1457,
	"./customersAggregator/paymenthistory": 1458,
	"./customersAggregator/paymenthistory.js": 1458,
	"./customersAggregator/players/filter": 1459,
	"./customersAggregator/players/filter.js": 1459,
	"./customersAggregator/players/table": 1460,
	"./customersAggregator/players/table.js": 1460,
	"./customersAggregator/playersAggregator/filter": 1461,
	"./customersAggregator/playersAggregator/filter.js": 1461,
	"./customersAggregator/playersAggregator/table": 1462,
	"./customersAggregator/playersAggregator/table.js": 1462,
	"./customersAggregator/positions": 1463,
	"./customersAggregator/positions.js": 1463,
	"./customersAggregator/reports/autoexclusionUsers": 1464,
	"./customersAggregator/reports/autoexclusionUsers.js": 1464,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1465,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1465,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1466,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1466,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1467,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1467,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1468,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1468,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1469,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1469,
	"./customersAggregator/reports/betsReport": 1470,
	"./customersAggregator/reports/betsReport.js": 1470,
	"./customersAggregator/reports/betsReport/detailsReport": 1471,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1471,
	"./customersAggregator/reports/betsReport/filterReport": 1472,
	"./customersAggregator/reports/betsReport/filterReport.js": 1472,
	"./customersAggregator/reports/betsReport/recordReport": 1473,
	"./customersAggregator/reports/betsReport/recordReport.js": 1473,
	"./customersAggregator/reports/betsReport/recordTableReport": 1474,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1474,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1475,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1475,
	"./customersAggregator/reports/betsReport/recordTransReport": 1476,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1476,
	"./customersAggregator/reports/betsReport/tableReport": 1477,
	"./customersAggregator/reports/betsReport/tableReport.js": 1477,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1478,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1478,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1479,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1479,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1480,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1480,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1481,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1481,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1482,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1482,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1483,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1483,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1484,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1484,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1485,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1485,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1486,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1486,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1487,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1487,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1488,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1488,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1489,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1489,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1490,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1490,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1491,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1491,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1492,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1492,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1493,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1493,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1494,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1494,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1495,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1495,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1496,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1496,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1497,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1497,
	"./customersAggregator/reportscustomer": 1498,
	"./customersAggregator/reportscustomer.js": 1498,
	"./customersAggregator/statistics": 1499,
	"./customersAggregator/statistics.js": 1499,
	"./customersAggregator/tags": 1500,
	"./customersAggregator/tags.js": 1500,
	"./dashboard": 1501,
	"./dashboard.js": 1501,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 494,
	"./dates.js": 494,
	"./demos": 1502,
	"./demos.js": 1502,
	"./depositReport": 1503,
	"./depositReport.js": 1503,
	"./depositReport2": 1504,
	"./depositReport2.js": 1504,
	"./depositReport3": 1505,
	"./depositReport3.js": 1505,
	"./depositReportBetShop": 1506,
	"./depositReportBetShop.js": 1506,
	"./depositRequests": 1507,
	"./depositRequests.js": 1507,
	"./eliminateNoteWithdraw": 1508,
	"./eliminateNoteWithdraw.js": 1508,
	"./emailsReport": 1509,
	"./emailsReport.js": 1509,
	"./financial/depositRequests/filter": 503,
	"./financial/depositRequests/filter.js": 503,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 505,
	"./financial/depositRequests/recordTable.js": 505,
	"./financial/depositRequests/table": 504,
	"./financial/depositRequests/table.js": 504,
	"./financial/withdrawalRequests": 1510,
	"./financial/withdrawalRequests.js": 1510,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 512,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 512,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1511,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1511,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 513,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 513,
	"./flujoCaja": 1512,
	"./flujoCaja.js": 1512,
	"./franchisee": 1513,
	"./franchisee.js": 1513,
	"./franchises": 1514,
	"./franchises.js": 1514,
	"./futureEvents": 1515,
	"./futureEvents.js": 1515,
	"./gamePerformanceReport": 1516,
	"./gamePerformanceReport.js": 1516,
	"./getReportStructureGames": 1517,
	"./getReportStructureGames.js": 1517,
	"./goldenRace": 1518,
	"./goldenRace.js": 1518,
	"./historicalCashFlow": 1519,
	"./historicalCashFlow.js": 1519,
	"./historyMovement": 1520,
	"./historyMovement.js": 1520,
	"./historyMovement/filter": 1521,
	"./historyMovement/filter.js": 1521,
	"./historyMovement/table": 1522,
	"./historyMovement/table.js": 1522,
	"./historyMovementBetShop": 1523,
	"./historyMovementBetShop.js": 1523,
	"./historyPoints": 1524,
	"./historyPoints.js": 1524,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1525,
	"./information/recordTable.js": 1525,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1526,
	"./informationCasino.js": 1526,
	"./informationHipica": 1527,
	"./informationHipica.js": 1527,
	"./informationLiveCasino": 1528,
	"./informationLiveCasino.js": 1528,
	"./informationVirtual": 1529,
	"./informationVirtual.js": 1529,
	"./informeCasino": 1530,
	"./informeCasino.js": 1530,
	"./informeGerencial": 1531,
	"./informeGerencial.js": 1531,
	"./informeGerencial2": 1532,
	"./informeGerencial2.js": 1532,
	"./informeGerencialAgentes2": 1533,
	"./informeGerencialAgentes2.js": 1533,
	"./informeGerencialUsuarios2": 1534,
	"./informeGerencialUsuarios2.js": 1534,
	"./jackpotInternationalReport2": 1535,
	"./jackpotInternationalReport2.js": 1535,
	"./jackpotPaymentReports": 1536,
	"./jackpotPaymentReports.js": 1536,
	"./jackpotPaymentReports2": 1537,
	"./jackpotPaymentReports2.js": 1537,
	"./jackpotPrizeReport": 1538,
	"./jackpotPrizeReport.js": 1538,
	"./jackpotPrizeReportSportBet": 1539,
	"./jackpotPrizeReportSportBet.js": 1539,
	"./jackpotWinnersReport": 1540,
	"./jackpotWinnersReport.js": 1540,
	"./landingReport": 1541,
	"./landingReport.js": 1541,
	"./landingReport2": 1542,
	"./landingReport2.js": 1542,
	"./leagues/AddLeague": 1543,
	"./leagues/AddLeague.js": 1543,
	"./leagues/addLeagueManagement": 1544,
	"./leagues/addLeagueManagement.js": 1544,
	"./leagues/configuration": 1545,
	"./leagues/configuration.js": 1545,
	"./leagues/configuration/changePassword": 1546,
	"./leagues/configuration/changePassword.js": 1546,
	"./leagues/configuration/changePassword/changePasswordView": 1547,
	"./leagues/configuration/changePassword/changePasswordView.js": 1547,
	"./leagues/configuration/generateToken": 1548,
	"./leagues/configuration/generateToken.js": 1548,
	"./leagues/configuration/generateToken/filter": 1549,
	"./leagues/configuration/generateToken/filter.js": 1549,
	"./leagues/configuration/generateToken/table": 1550,
	"./leagues/configuration/generateToken/table.js": 1550,
	"./leagues/configuration/qrgoogle": 1551,
	"./leagues/configuration/qrgoogle.js": 1551,
	"./leagues/configuration/securityChanges": 1552,
	"./leagues/configuration/securityChanges.js": 1552,
	"./leagues/configuration/securityChanges/filter": 1553,
	"./leagues/configuration/securityChanges/filter.js": 1553,
	"./leagues/configuration/securityChanges/table": 1554,
	"./leagues/configuration/securityChanges/table.js": 1554,
	"./leagues/information": 1555,
	"./leagues/information.js": 1555,
	"./leagues/leagues-list/filter": 565,
	"./leagues/leagues-list/filter.js": 565,
	"./leagues/leagues-list/table": 566,
	"./leagues/leagues-list/table.js": 566,
	"./leagues/leaguesList": 1556,
	"./leagues/leaguesList.js": 1556,
	"./leagues/leaguesManagement": 1557,
	"./leagues/leaguesManagement.js": 1557,
	"./leagues/reports": 1558,
	"./leagues/reports.js": 1558,
	"./leagues/reports/betsReport": 1559,
	"./leagues/reports/betsReport.js": 1559,
	"./leagues/reports/betsReport/detailsReport": 1560,
	"./leagues/reports/betsReport/detailsReport.js": 1560,
	"./leagues/reports/betsReport/filterReport": 568,
	"./leagues/reports/betsReport/filterReport.js": 568,
	"./leagues/reports/betsReport/recordReport": 1561,
	"./leagues/reports/betsReport/recordReport.js": 1561,
	"./leagues/reports/betsReport/recordTableReport": 1562,
	"./leagues/reports/betsReport/recordTableReport.js": 1562,
	"./leagues/reports/betsReport/recordTableTransReport": 1563,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1563,
	"./leagues/reports/betsReport/recordTransReport": 570,
	"./leagues/reports/betsReport/recordTransReport.js": 570,
	"./leagues/reports/betsReport/tableReport": 569,
	"./leagues/reports/betsReport/tableReport.js": 569,
	"./leagues/reports/casinoGamesReport": 1564,
	"./leagues/reports/casinoGamesReport.js": 1564,
	"./leagues/reports/casinoReport/detailsCasinoReport": 573,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 573,
	"./leagues/reports/casinoReport/filterCasinoReport": 571,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 571,
	"./leagues/reports/casinoReport/recordCasinoReport": 574,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 574,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1565,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1565,
	"./leagues/reports/casinoReport/tableCasinoReport": 572,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 572,
	"./leagues/reports/userAfilliatesReport": 1566,
	"./leagues/reports/userAfilliatesReport.js": 1566,
	"./leagues/reports/user_affiliates/detailsReports": 1567,
	"./leagues/reports/user_affiliates/detailsReports.js": 1567,
	"./leagues/reports/user_affiliates/filterReports": 575,
	"./leagues/reports/user_affiliates/filterReports.js": 575,
	"./leagues/reports/user_affiliates/recordReports": 1568,
	"./leagues/reports/user_affiliates/recordReports.js": 1568,
	"./leagues/reports/user_affiliates/recordTableReports": 1569,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1569,
	"./leagues/reports/user_affiliates/tableReports": 576,
	"./leagues/reports/user_affiliates/tableReports.js": 576,
	"./leagues/results/recordTableResponts": 567,
	"./leagues/results/recordTableResponts.js": 567,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1570,
	"./leagues/statistics.js": 1570,
	"./leagues/statistics/age": 580,
	"./leagues/statistics/age.js": 580,
	"./leagues/statistics/marketing": 578,
	"./leagues/statistics/marketing.js": 578,
	"./leagues/statistics/marketingvsregistros": 579,
	"./leagues/statistics/marketingvsregistros.js": 579,
	"./leagues/statistics/money": 577,
	"./leagues/statistics/money.js": 577,
	"./limitationsReport": 1571,
	"./limitationsReport.js": 1571,
	"./loading": 1572,
	"./loading.js": 1572,
	"./login": 1573,
	"./login.js": 1573,
	"./logsUserGeneral": 1574,
	"./logsUserGeneral.js": 1574,
	"./loteryReport": 1575,
	"./loteryReport.js": 1575,
	"./loyaltyLevelChangeHistory": 1576,
	"./loyaltyLevelChangeHistory.js": 1576,
	"./machine/AddMachineRegister": 1577,
	"./machine/AddMachineRegister.js": 1577,
	"./machine/addMachineManagement": 1578,
	"./machine/addMachineManagement.js": 1578,
	"./machine/cashier/advertising": 590,
	"./machine/cashier/advertising.js": 590,
	"./machine/cashier/cashier": 1579,
	"./machine/cashier/cashier.js": 1579,
	"./machine/cashier/tableAdvertising": 591,
	"./machine/cashier/tableAdvertising.js": 591,
	"./machine/configuration": 1580,
	"./machine/configuration.js": 1580,
	"./machine/configuration/changePassword": 1581,
	"./machine/configuration/changePassword.js": 1581,
	"./machine/configuration/changePassword/changePasswordView": 1582,
	"./machine/configuration/changePassword/changePasswordView.js": 1582,
	"./machine/configuration/generateToken": 1583,
	"./machine/configuration/generateToken.js": 1583,
	"./machine/configuration/generateToken/filter": 1584,
	"./machine/configuration/generateToken/filter.js": 1584,
	"./machine/configuration/generateToken/table": 1585,
	"./machine/configuration/generateToken/table.js": 1585,
	"./machine/configuration/qrgoogle": 1586,
	"./machine/configuration/qrgoogle.js": 1586,
	"./machine/configuration/securityChanges": 1587,
	"./machine/configuration/securityChanges.js": 1587,
	"./machine/configuration/securityChanges/filter": 1025,
	"./machine/configuration/securityChanges/filter.js": 1025,
	"./machine/configuration/securityChanges/table": 592,
	"./machine/configuration/securityChanges/table.js": 592,
	"./machine/filter": 593,
	"./machine/filter.js": 593,
	"./machine/information": 1588,
	"./machine/information.js": 1588,
	"./machine/machineManagement": 1589,
	"./machine/machineManagement.js": 1589,
	"./machine/machineRegister": 1590,
	"./machine/machineRegister.js": 1590,
	"./machine/managePointsGraphics": 1591,
	"./machine/managePointsGraphics.js": 1591,
	"./machine/pagoNotaCobro": 1592,
	"./machine/pagoNotaCobro.js": 1592,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1026,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1026,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 597,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 597,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 598,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 598,
	"./machine/pagoPremioMaquina": 1593,
	"./machine/pagoPremioMaquina.js": 1593,
	"./machine/pagopremio/PagoPremio": 600,
	"./machine/pagopremio/PagoPremio.js": 600,
	"./machine/pagopremio/detailsPagoPremio": 602,
	"./machine/pagopremio/detailsPagoPremio.js": 602,
	"./machine/pagopremio/filterPagoPremio": 599,
	"./machine/pagopremio/filterPagoPremio.js": 599,
	"./machine/pagopremio/recordPagoPremio": 603,
	"./machine/pagopremio/recordPagoPremio.js": 603,
	"./machine/pagopremio/recordTablePagoPremio": 1594,
	"./machine/pagopremio/recordTablePagoPremio.js": 1594,
	"./machine/pagopremio/tablePagoPremio": 601,
	"./machine/pagopremio/tablePagoPremio.js": 601,
	"./machine/pointsGraphics/filter": 595,
	"./machine/pointsGraphics/filter.js": 595,
	"./machine/pointsGraphics/pointsList": 596,
	"./machine/pointsGraphics/pointsList.js": 596,
	"./machine/products2": 1595,
	"./machine/products2.js": 1595,
	"./machine/products2/categories-products/filter": 604,
	"./machine/products2/categories-products/filter.js": 604,
	"./machine/products2/categories-products/table": 605,
	"./machine/products2/categories-products/table.js": 605,
	"./machine/products2/categoriesProducts": 1596,
	"./machine/products2/categoriesProducts.js": 1596,
	"./machine/products2/partners-games/filter": 606,
	"./machine/products2/partners-games/filter.js": 606,
	"./machine/products2/partners-games/table": 607,
	"./machine/products2/partners-games/table.js": 607,
	"./machine/products2/partners-products/filter": 608,
	"./machine/products2/partners-products/filter.js": 608,
	"./machine/products2/partners-products/table": 609,
	"./machine/products2/partners-products/table.js": 609,
	"./machine/products2/partners-providers/filter": 610,
	"./machine/products2/partners-providers/filter.js": 610,
	"./machine/products2/partners-providers/table": 611,
	"./machine/products2/partners-providers/table.js": 611,
	"./machine/products2/partners-subProviders/filter": 612,
	"./machine/products2/partners-subProviders/filter.js": 612,
	"./machine/products2/partners-subProviders/table": 613,
	"./machine/products2/partners-subProviders/table.js": 613,
	"./machine/products2/partners-tipoproducto/filter": 614,
	"./machine/products2/partners-tipoproducto/filter.js": 614,
	"./machine/products2/partners-tipoproducto/table": 615,
	"./machine/products2/partners-tipoproducto/table.js": 615,
	"./machine/products2/partnersGames": 1597,
	"./machine/products2/partnersGames.js": 1597,
	"./machine/products2/partnersProducts": 1598,
	"./machine/products2/partnersProducts.js": 1598,
	"./machine/products2/partnersProviders": 1599,
	"./machine/products2/partnersProviders.js": 1599,
	"./machine/products2/partnersSubProviders": 1600,
	"./machine/products2/partnersSubProviders.js": 1600,
	"./machine/products2/partnersTypeProduct": 1601,
	"./machine/products2/partnersTypeProduct.js": 1601,
	"./machine/reports": 1602,
	"./machine/reports.js": 1602,
	"./machine/reports/betsReport": 1603,
	"./machine/reports/betsReport.js": 1603,
	"./machine/reports/betsReport/detailsReport": 1604,
	"./machine/reports/betsReport/detailsReport.js": 1604,
	"./machine/reports/betsReport/filterReport": 616,
	"./machine/reports/betsReport/filterReport.js": 616,
	"./machine/reports/betsReport/recordReport": 1605,
	"./machine/reports/betsReport/recordReport.js": 1605,
	"./machine/reports/betsReport/recordTableReport": 1606,
	"./machine/reports/betsReport/recordTableReport.js": 1606,
	"./machine/reports/betsReport/recordTableTransReport": 1607,
	"./machine/reports/betsReport/recordTableTransReport.js": 1607,
	"./machine/reports/betsReport/recordTransReport": 618,
	"./machine/reports/betsReport/recordTransReport.js": 618,
	"./machine/reports/betsReport/tableReport": 617,
	"./machine/reports/betsReport/tableReport.js": 617,
	"./machine/reports/casinoGamesReport": 1608,
	"./machine/reports/casinoGamesReport.js": 1608,
	"./machine/reports/casinoReport/detailsCasinoReport": 621,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 621,
	"./machine/reports/casinoReport/filterCasinoReport": 619,
	"./machine/reports/casinoReport/filterCasinoReport.js": 619,
	"./machine/reports/casinoReport/recordCasinoReport": 622,
	"./machine/reports/casinoReport/recordCasinoReport.js": 622,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1609,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1609,
	"./machine/reports/casinoReport/tableCasinoReport": 620,
	"./machine/reports/casinoReport/tableCasinoReport.js": 620,
	"./machine/reports/depositReport": 1610,
	"./machine/reports/depositReport.js": 1610,
	"./machine/reports/deposit_report/detailsDepositReports": 1027,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1027,
	"./machine/reports/deposit_report/filterDepositReports": 623,
	"./machine/reports/deposit_report/filterDepositReports.js": 623,
	"./machine/reports/deposit_report/recordDepositReports": 625,
	"./machine/reports/deposit_report/recordDepositReports.js": 625,
	"./machine/reports/deposit_report/recordTableDepositReports": 1611,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1611,
	"./machine/reports/deposit_report/tableDepositReports": 624,
	"./machine/reports/deposit_report/tableDepositReports.js": 624,
	"./machine/reports/flujoCaja": 1612,
	"./machine/reports/flujoCaja.js": 1612,
	"./machine/reports/flujocaja/detailsFlujoCaja": 628,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 628,
	"./machine/reports/flujocaja/filterFlujoCaja": 626,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 626,
	"./machine/reports/flujocaja/recordFlujoCaja": 629,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 629,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1613,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1613,
	"./machine/reports/flujocaja/tableFlujoCaja": 627,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 627,
	"./machine/reports/log/log": 630,
	"./machine/reports/log/log.js": 630,
	"./machine/reports/logReport": 1614,
	"./machine/reports/logReport.js": 1614,
	"./machine/reports/updates/filter": 631,
	"./machine/reports/updates/filter.js": 631,
	"./machine/reports/updates/table": 632,
	"./machine/reports/updates/table.js": 632,
	"./machine/reports/updatesReport": 1615,
	"./machine/reports/updatesReport.js": 1615,
	"./machine/reports/userAfilliatesReport": 1616,
	"./machine/reports/userAfilliatesReport.js": 1616,
	"./machine/reports/user_affiliates/detailsReports": 1617,
	"./machine/reports/user_affiliates/detailsReports.js": 1617,
	"./machine/reports/user_affiliates/filterReports": 633,
	"./machine/reports/user_affiliates/filterReports.js": 633,
	"./machine/reports/user_affiliates/recordReports": 1618,
	"./machine/reports/user_affiliates/recordReports.js": 1618,
	"./machine/reports/user_affiliates/recordTableReports": 1619,
	"./machine/reports/user_affiliates/recordTableReports.js": 1619,
	"./machine/reports/user_affiliates/tableReports": 634,
	"./machine/reports/user_affiliates/tableReports.js": 634,
	"./machine/reports/withdrawalRequests": 1620,
	"./machine/reports/withdrawalRequests.js": 1620,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 637,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 637,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 635,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 635,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1621,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1621,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 638,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 638,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 636,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 636,
	"./machine/results/recordTableResponts": 1622,
	"./machine/results/recordTableResponts.js": 1622,
	"./machine/results/tableResults": 1623,
	"./machine/results/tableResults.js": 1623,
	"./machine/statistics": 1624,
	"./machine/statistics.js": 1624,
	"./machine/statistics/age": 642,
	"./machine/statistics/age.js": 642,
	"./machine/statistics/marketing": 640,
	"./machine/statistics/marketing.js": 640,
	"./machine/statistics/marketingvsregistros": 641,
	"./machine/statistics/marketingvsregistros.js": 641,
	"./machine/statistics/money": 639,
	"./machine/statistics/money.js": 639,
	"./machine/table": 594,
	"./machine/table.js": 594,
	"./management/activateRegistration/filter": 203,
	"./management/activateRegistration/filter.js": 203,
	"./management/activateRegistration/response": 204,
	"./management/activateRegistration/response.js": 204,
	"./management/coupons/coupons": 444,
	"./management/coupons/coupons.js": 444,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 507,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 507,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 506,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 506,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 509,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 509,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 508,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 508,
	"./management/faltan.txt": 1954,
	"./management/managementClaims/filter": 643,
	"./management/managementClaims/filter.js": 643,
	"./management/managementClaims/table": 644,
	"./management/managementClaims/table.js": 644,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 645,
	"./management/managementContact/detailsTable.js": 645,
	"./management/managementContact/filterManagementContact": 646,
	"./management/managementContact/filterManagementContact.js": 646,
	"./management/managementContact/tableManagementContact": 647,
	"./management/managementContact/tableManagementContact.js": 647,
	"./management/managementContactUser/filter": 648,
	"./management/managementContactUser/filter.js": 648,
	"./management/managementContactUser/table": 649,
	"./management/managementContactUser/table.js": 649,
	"./management/managementGenericForms/filter": 650,
	"./management/managementGenericForms/filter.js": 650,
	"./management/managementGenericForms/table": 651,
	"./management/managementGenericForms/table.js": 651,
	"./management/quotaRetraction/Retraction": 652,
	"./management/quotaRetraction/Retraction.js": 652,
	"./management/quotaRetraction/search": 1028,
	"./management/quotaRetraction/search.js": 1028,
	"./management/registerFast/filterRegisterFast": 653,
	"./management/registerFast/filterRegisterFast.js": 653,
	"./management/registerFast/tableRegisterFast": 654,
	"./management/registerFast/tableRegisterFast.js": 654,
	"./management/reprintCheck/filterReprintCheck": 655,
	"./management/reprintCheck/filterReprintCheck.js": 655,
	"./management/reprintCheck/tableReprintCheck": 656,
	"./management/reprintCheck/tableReprintCheck.js": 656,
	"./management/restrictUser/filter": 657,
	"./management/restrictUser/filter.js": 657,
	"./management/restrictUser/table": 658,
	"./management/restrictUser/table.js": 658,
	"./management/reversionReload/filterReversionReload": 659,
	"./management/reversionReload/filterReversionReload.js": 659,
	"./management/reversionReload/tableReversionReload": 660,
	"./management/reversionReload/tableReversionReload.js": 660,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 661,
	"./management/usersVerification/informationJumio.js": 661,
	"./managementClaims": 1625,
	"./managementClaims.js": 1625,
	"./managementContact": 1626,
	"./managementContact.js": 1626,
	"./managementContactUser": 1627,
	"./managementContactUser.js": 1627,
	"./managementGenericForms": 1628,
	"./managementGenericForms.js": 1628,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1629,
	"./menuBonus.js": 1629,
	"./menuBuilder": 1630,
	"./menuBuilder.js": 1630,
	"./menuMarketing": 1631,
	"./menuMarketing.js": 1631,
	"./menus": 1632,
	"./menus.js": 1632,
	"./messages/bannerInvasive": 1633,
	"./messages/bannerInvasive.js": 1633,
	"./messages/bannerInvasive/filter": 664,
	"./messages/bannerInvasive/filter.js": 664,
	"./messages/bannerInvasive/table": 665,
	"./messages/bannerInvasive/table.js": 665,
	"./messages/fringe": 1634,
	"./messages/fringe.js": 1634,
	"./messages/fringe/filter": 666,
	"./messages/fringe/filter.js": 666,
	"./messages/fringe/table": 667,
	"./messages/fringe/table.js": 667,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 668,
	"./messages/messageInternAgent/filter.js": 668,
	"./messages/messageInternAgent/table": 669,
	"./messages/messageInternAgent/table.js": 669,
	"./messages/messageInternal": 1635,
	"./messages/messageInternal.js": 1635,
	"./messages/messageInternalAgent": 1636,
	"./messages/messageInternalAgent.js": 1636,
	"./messages/messageList": 1637,
	"./messages/messageList.js": 1637,
	"./messages/popup": 1638,
	"./messages/popup.js": 1638,
	"./messages/popup/filter": 670,
	"./messages/popup/filter.js": 670,
	"./messages/popup/table": 671,
	"./messages/popup/table.js": 671,
	"./messagesOld/messageIntern/filter": 1639,
	"./messagesOld/messageIntern/filter.js": 1639,
	"./messagesOld/messageIntern/table": 1640,
	"./messagesOld/messageIntern/table.js": 1640,
	"./messagesOld/messageList": 1641,
	"./messagesOld/messageList.js": 1641,
	"./myComissionsReport": 1642,
	"./myComissionsReport.js": 1642,
	"./myConfiguration/changeMyPassword": 1643,
	"./myConfiguration/changeMyPassword.js": 1643,
	"./myConfiguration/myInfoBetShop": 1644,
	"./myConfiguration/myInfoBetShop.js": 1644,
	"./myConfiguration/myInfoCustomer": 1645,
	"./myConfiguration/myInfoCustomer.js": 1645,
	"./myConfiguration/myInformation": 1646,
	"./myConfiguration/myInformation.js": 1646,
	"./myConfiguration/qrgoogle": 1647,
	"./myConfiguration/qrgoogle.js": 1647,
	"./notesUser": 1648,
	"./notesUser.js": 1648,
	"./notifications": 999,
	"./notifications.js": 999,
	"./operatorResponsibility": 1649,
	"./operatorResponsibility.js": 1649,
	"./ownersIncome": 1650,
	"./ownersIncome.js": 1650,
	"./ownersIncomeSecondLevel": 1651,
	"./ownersIncomeSecondLevel.js": 1651,
	"./pagoNotaRetiro": 1652,
	"./pagoNotaRetiro.js": 1652,
	"./pagoPremio": 1653,
	"./pagoPremio.js": 1653,
	"./pagoPremioVirtuales": 1654,
	"./pagoPremioVirtuales.js": 1654,
	"./paidPendingAwards": 1655,
	"./paidPendingAwards.js": 1655,
	"./partner/PartnerSettings": 1656,
	"./partner/PartnerSettings.js": 1656,
	"./partner/PartnerSettingsOld": 1657,
	"./partner/PartnerSettingsOld.js": 1657,
	"./partner/TRM": 1658,
	"./partner/TRM.js": 1658,
	"./partner/TRM/filter": 686,
	"./partner/TRM/filter.js": 686,
	"./partner/TRM/table": 687,
	"./partner/TRM/table.js": 687,
	"./partner/configuration": 1659,
	"./partner/configuration.js": 1659,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1660,
	"./partner/configurationControl.js": 1660,
	"./partner/configurationControl/filter": 688,
	"./partner/configurationControl/filter.js": 688,
	"./partner/configurationControl/table": 689,
	"./partner/configurationControl/table.js": 689,
	"./partner/configurationControl2": 1661,
	"./partner/configurationControl2.js": 1661,
	"./partner/configurationControl2/filter": 690,
	"./partner/configurationControl2/filter.js": 690,
	"./partner/configurationControl2/table": 691,
	"./partner/configurationControl2/table.js": 691,
	"./partner/configurationOld/filter": 1662,
	"./partner/configurationOld/filter.js": 1662,
	"./partner/configurationOld/settings": 1663,
	"./partner/configurationOld/settings.js": 1663,
	"./partner/configurationSEO": 1664,
	"./partner/configurationSEO.js": 1664,
	"./partner/configurationSEO/filter": 692,
	"./partner/configurationSEO/filter.js": 692,
	"./partner/configurationSEO/settings": 693,
	"./partner/configurationSEO/settings.js": 693,
	"./partner/countries": 1665,
	"./partner/countries.js": 1665,
	"./partner/countries/countries": 694,
	"./partner/countries/countries.js": 694,
	"./partner/menusUser": 1666,
	"./partner/menusUser.js": 1666,
	"./partner/menusUser/filter": 695,
	"./partner/menusUser/filter.js": 695,
	"./partner/menusUser/table": 696,
	"./partner/menusUser/table.js": 696,
	"./partner/partner-list/filter": 684,
	"./partner/partner-list/filter.js": 684,
	"./partner/partner-list/table": 685,
	"./partner/partner-list/table.js": 685,
	"./partner/partnertManagement": 1667,
	"./partner/partnertManagement.js": 1667,
	"./partner/products": 1668,
	"./partner/products.js": 1668,
	"./partner/products/categories-products/filter": 697,
	"./partner/products/categories-products/filter.js": 697,
	"./partner/products/categories-products/table": 698,
	"./partner/products/categories-products/table.js": 698,
	"./partner/products/categoriesProducts": 1669,
	"./partner/products/categoriesProducts.js": 1669,
	"./partner/products/partners-products/filter": 699,
	"./partner/products/partners-products/filter.js": 699,
	"./partner/products/partners-products/table": 700,
	"./partner/products/partners-products/table.js": 700,
	"./partner/products/partners-providers/filter": 701,
	"./partner/products/partners-providers/filter.js": 701,
	"./partner/products/partners-providers/table": 702,
	"./partner/products/partners-providers/table.js": 702,
	"./partner/products/partners-subProviders/filter": 703,
	"./partner/products/partners-subProviders/filter.js": 703,
	"./partner/products/partners-subProviders/table": 704,
	"./partner/products/partners-subProviders/table.js": 704,
	"./partner/products/partners-tipoproducto/filter": 705,
	"./partner/products/partners-tipoproducto/filter.js": 705,
	"./partner/products/partners-tipoproducto/table": 706,
	"./partner/products/partners-tipoproducto/table.js": 706,
	"./partner/products/partnersProducts": 1670,
	"./partner/products/partnersProducts.js": 1670,
	"./partner/products/partnersProviders": 1671,
	"./partner/products/partnersProviders.js": 1671,
	"./partner/products/partnersSubProviders": 1672,
	"./partner/products/partnersSubProviders.js": 1672,
	"./partner/products/partnersTypeProduct": 1673,
	"./partner/products/partnersTypeProduct.js": 1673,
	"./partner/products/products-banks/filter": 707,
	"./partner/products/products-banks/filter.js": 707,
	"./partner/products/products-banks/table": 708,
	"./partner/products/products-banks/table.js": 708,
	"./partner/products/products-cryptoNetwork/filter": 709,
	"./partner/products/products-cryptoNetwork/filter.js": 709,
	"./partner/products/products-cryptoNetwork/table": 710,
	"./partner/products/products-cryptoNetwork/table.js": 710,
	"./partner/products/products-franchises/filter": 711,
	"./partner/products/products-franchises/filter.js": 711,
	"./partner/products/products-franchises/table": 712,
	"./partner/products/products-franchises/table.js": 712,
	"./partner/products/productsBanks": 1674,
	"./partner/products/productsBanks.js": 1674,
	"./partner/products/productsCryptoNetwork": 1675,
	"./partner/products/productsCryptoNetwork.js": 1675,
	"./partner/products/productsFranchises": 1676,
	"./partner/products/productsFranchises.js": 1676,
	"./partner/products2": 1677,
	"./partner/products2.js": 1677,
	"./partner/products2/banks-partners/filter": 713,
	"./partner/products2/banks-partners/filter.js": 713,
	"./partner/products2/banks-partners/table": 714,
	"./partner/products2/banks-partners/table.js": 714,
	"./partner/products2/categories-products/filter": 715,
	"./partner/products2/categories-products/filter.js": 715,
	"./partner/products2/categories-products/table": 716,
	"./partner/products2/categories-products/table.js": 716,
	"./partner/products2/categoriesProducts": 1678,
	"./partner/products2/categoriesProducts.js": 1678,
	"./partner/products2/enablement-products/filter": 717,
	"./partner/products2/enablement-products/filter.js": 717,
	"./partner/products2/enablement-products/table": 718,
	"./partner/products2/enablement-products/table.js": 718,
	"./partner/products2/enablementProducts": 1679,
	"./partner/products2/enablementProducts.js": 1679,
	"./partner/products2/franchises-partner/filter": 719,
	"./partner/products2/franchises-partner/filter.js": 719,
	"./partner/products2/franchises-partner/table": 720,
	"./partner/products2/franchises-partner/table.js": 720,
	"./partner/products2/partners-categories/filter": 721,
	"./partner/products2/partners-categories/filter.js": 721,
	"./partner/products2/partners-categories/table": 722,
	"./partner/products2/partners-categories/table.js": 722,
	"./partner/products2/partners-credentialsSubProviders/filter": 723,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 723,
	"./partner/products2/partners-credentialsSubProviders/table": 724,
	"./partner/products2/partners-credentialsSubProviders/table.js": 724,
	"./partner/products2/partners-games/filter": 725,
	"./partner/products2/partners-games/filter.js": 725,
	"./partner/products2/partners-games/table": 726,
	"./partner/products2/partners-games/table.js": 726,
	"./partner/products2/partners-products/filter": 727,
	"./partner/products2/partners-products/filter.js": 727,
	"./partner/products2/partners-products/table": 728,
	"./partner/products2/partners-products/table.js": 728,
	"./partner/products2/partners-providers-order/filter": 1680,
	"./partner/products2/partners-providers-order/filter.js": 1680,
	"./partner/products2/partners-providers-order/table": 1681,
	"./partner/products2/partners-providers-order/table.js": 1681,
	"./partner/products2/partners-providers/filter": 729,
	"./partner/products2/partners-providers/filter.js": 729,
	"./partner/products2/partners-providers/table": 730,
	"./partner/products2/partners-providers/table.js": 730,
	"./partner/products2/partners-subProviders-order/filter": 731,
	"./partner/products2/partners-subProviders-order/filter.js": 731,
	"./partner/products2/partners-subProviders-order/table": 732,
	"./partner/products2/partners-subProviders-order/table.js": 732,
	"./partner/products2/partners-subProviders/filter": 733,
	"./partner/products2/partners-subProviders/filter.js": 733,
	"./partner/products2/partners-subProviders/table": 734,
	"./partner/products2/partners-subProviders/table.js": 734,
	"./partner/products2/partners-tipoproducto/filter": 735,
	"./partner/products2/partners-tipoproducto/filter.js": 735,
	"./partner/products2/partners-tipoproducto/table": 736,
	"./partner/products2/partners-tipoproducto/table.js": 736,
	"./partner/products2/partnersBanks": 1682,
	"./partner/products2/partnersBanks.js": 1682,
	"./partner/products2/partnersCategories": 1683,
	"./partner/products2/partnersCategories.js": 1683,
	"./partner/products2/partnersCredentialsSubProviders": 1684,
	"./partner/products2/partnersCredentialsSubProviders.js": 1684,
	"./partner/products2/partnersFranchises": 1685,
	"./partner/products2/partnersFranchises.js": 1685,
	"./partner/products2/partnersGames": 1686,
	"./partner/products2/partnersGames.js": 1686,
	"./partner/products2/partnersProducts": 1687,
	"./partner/products2/partnersProducts.js": 1687,
	"./partner/products2/partnersProviders": 1688,
	"./partner/products2/partnersProviders.js": 1688,
	"./partner/products2/partnersSubProviders": 1689,
	"./partner/products2/partnersSubProviders.js": 1689,
	"./partner/products2/partnersSubProvidersOrder": 1690,
	"./partner/products2/partnersSubProvidersOrder.js": 1690,
	"./partner/products2/partnersTypeProduct": 1691,
	"./partner/products2/partnersTypeProduct.js": 1691,
	"./partner/reports": 1692,
	"./partner/reports.js": 1692,
	"./partner/reports/autoexclusionUsers": 1693,
	"./partner/reports/autoexclusionUsers.js": 1693,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 739,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 739,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 737,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 737,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1029,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1029,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 740,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 740,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 738,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 738,
	"./partner/reports/balanceAdjustments": 1694,
	"./partner/reports/balanceAdjustments.js": 1694,
	"./partner/reports/balanceAdjustments/filter": 741,
	"./partner/reports/balanceAdjustments/filter.js": 741,
	"./partner/reports/balanceAdjustments/table": 742,
	"./partner/reports/balanceAdjustments/table.js": 742,
	"./partner/reports/balanceHistory": 1695,
	"./partner/reports/balanceHistory.js": 1695,
	"./partner/reports/balanceHistory/filter": 743,
	"./partner/reports/balanceHistory/filter.js": 743,
	"./partner/reports/balanceHistory/table": 744,
	"./partner/reports/balanceHistory/table.js": 744,
	"./partner/reports/balanceHistoryBetShop": 1696,
	"./partner/reports/balanceHistoryBetShop.js": 1696,
	"./partner/reports/balanceHistoryBetShop/filter": 745,
	"./partner/reports/balanceHistoryBetShop/filter.js": 745,
	"./partner/reports/balanceHistoryBetShop/table": 746,
	"./partner/reports/balanceHistoryBetShop/table.js": 746,
	"./partner/reports/balanceUsers": 1697,
	"./partner/reports/balanceUsers.js": 1697,
	"./partner/reports/balanceUsers/filter": 747,
	"./partner/reports/balanceUsers/filter.js": 747,
	"./partner/reports/balanceUsers/record": 749,
	"./partner/reports/balanceUsers/record.js": 749,
	"./partner/reports/balanceUsers/resume": 750,
	"./partner/reports/balanceUsers/resume.js": 750,
	"./partner/reports/balanceUsers/table": 748,
	"./partner/reports/balanceUsers/table.js": 748,
	"./partner/reports/betsReport": 1698,
	"./partner/reports/betsReport.js": 1698,
	"./partner/reports/betsReport/detailsReport": 1699,
	"./partner/reports/betsReport/detailsReport.js": 1699,
	"./partner/reports/betsReport/filterReport": 751,
	"./partner/reports/betsReport/filterReport.js": 751,
	"./partner/reports/betsReport/recordReport": 755,
	"./partner/reports/betsReport/recordReport.js": 755,
	"./partner/reports/betsReport/recordTableReport": 756,
	"./partner/reports/betsReport/recordTableReport.js": 756,
	"./partner/reports/betsReport/recordTableTransReport": 754,
	"./partner/reports/betsReport/recordTableTransReport.js": 754,
	"./partner/reports/betsReport/recordTransReport": 753,
	"./partner/reports/betsReport/recordTransReport.js": 753,
	"./partner/reports/betsReport/tableReport": 752,
	"./partner/reports/betsReport/tableReport.js": 752,
	"./partner/reports/bonusReport": 1700,
	"./partner/reports/bonusReport.js": 1700,
	"./partner/reports/bonusReport/detailsBonusReport": 759,
	"./partner/reports/bonusReport/detailsBonusReport.js": 759,
	"./partner/reports/bonusReport/filterBonusReport": 757,
	"./partner/reports/bonusReport/filterBonusReport.js": 757,
	"./partner/reports/bonusReport/recordBonusReport": 760,
	"./partner/reports/bonusReport/recordBonusReport.js": 760,
	"./partner/reports/bonusReport/recordTableBonusReport": 761,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 761,
	"./partner/reports/bonusReport/tableBonusReport": 758,
	"./partner/reports/bonusReport/tableBonusReport.js": 758,
	"./partner/reports/casinoGamesReport": 1701,
	"./partner/reports/casinoGamesReport.js": 1701,
	"./partner/reports/casinoReport/detailsCasinoReport": 764,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 764,
	"./partner/reports/casinoReport/filterCasinoReport": 762,
	"./partner/reports/casinoReport/filterCasinoReport.js": 762,
	"./partner/reports/casinoReport/recordCasinoReport": 765,
	"./partner/reports/casinoReport/recordCasinoReport.js": 765,
	"./partner/reports/casinoReport/recordTableCasinoReport": 766,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 766,
	"./partner/reports/casinoReport/tableCasinoReport": 763,
	"./partner/reports/casinoReport/tableCasinoReport.js": 763,
	"./partner/reports/comissionsReport": 1702,
	"./partner/reports/comissionsReport.js": 1702,
	"./partner/reports/comissions_report/filter": 767,
	"./partner/reports/comissions_report/filter.js": 767,
	"./partner/reports/comissions_report/table": 768,
	"./partner/reports/comissions_report/table.js": 768,
	"./partner/reports/depositReport": 1703,
	"./partner/reports/depositReport.js": 1703,
	"./partner/reports/deposit_report/detailsDepositReports": 1030,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1030,
	"./partner/reports/deposit_report/filterDepositReports": 769,
	"./partner/reports/deposit_report/filterDepositReports.js": 769,
	"./partner/reports/deposit_report/recordDepositReports": 771,
	"./partner/reports/deposit_report/recordDepositReports.js": 771,
	"./partner/reports/deposit_report/recordTableDepositReports": 772,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 772,
	"./partner/reports/deposit_report/tableDepositReports": 770,
	"./partner/reports/deposit_report/tableDepositReports.js": 770,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 773,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 773,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 774,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 774,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 775,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 775,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 776,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 776,
	"./partner/reports/historicalCashFlow": 1704,
	"./partner/reports/historicalCashFlow.js": 1704,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 779,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 779,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 777,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 777,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 780,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 780,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 781,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 781,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 778,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 778,
	"./partner/reports/historyMovement": 1705,
	"./partner/reports/historyMovement.js": 1705,
	"./partner/reports/historyMovement/filter": 782,
	"./partner/reports/historyMovement/filter.js": 782,
	"./partner/reports/historyMovement/table": 783,
	"./partner/reports/historyMovement/table.js": 783,
	"./partner/reports/informeCasino/detailsInformeCasino": 1706,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1706,
	"./partner/reports/informeCasino/filterInformeCasino": 1707,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1707,
	"./partner/reports/informeCasino/recordInformeCasino": 1708,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1708,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1709,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1709,
	"./partner/reports/informeCasino/tableInformeCasino": 1710,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1710,
	"./partner/reports/informeGerencial": 1711,
	"./partner/reports/informeGerencial.js": 1711,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 786,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 786,
	"./partner/reports/informeGerencial/filterInformeGerencial": 784,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 784,
	"./partner/reports/informeGerencial/recordInformeGerencial": 787,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 787,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 788,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 788,
	"./partner/reports/informeGerencial/tableInformeGerencial": 785,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 785,
	"./partner/reports/landingReport/detailsLandingReport": 1712,
	"./partner/reports/landingReport/detailsLandingReport.js": 1712,
	"./partner/reports/landingReport/filterLandingReport": 1713,
	"./partner/reports/landingReport/filterLandingReport.js": 1713,
	"./partner/reports/landingReport/recordLandingReport": 1714,
	"./partner/reports/landingReport/recordLandingReport.js": 1714,
	"./partner/reports/landingReport/recordTableLandingReport": 1715,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1715,
	"./partner/reports/landingReport/tableLandingReport": 1716,
	"./partner/reports/landingReport/tableLandingReport.js": 1716,
	"./partner/reports/logsUser/filter": 1717,
	"./partner/reports/logsUser/filter.js": 1717,
	"./partner/reports/logsUser/table": 1718,
	"./partner/reports/logsUser/table.js": 1718,
	"./partner/reports/operatorResponsibility/filter": 1719,
	"./partner/reports/operatorResponsibility/filter.js": 1719,
	"./partner/reports/operatorResponsibility/table": 1720,
	"./partner/reports/operatorResponsibility/table.js": 1720,
	"./partner/reports/paidPendingAwards": 1721,
	"./partner/reports/paidPendingAwards.js": 1721,
	"./partner/reports/playersReport/detailsPlayersReport": 1722,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1722,
	"./partner/reports/playersReport/filterPlayersReport": 1723,
	"./partner/reports/playersReport/filterPlayersReport.js": 1723,
	"./partner/reports/playersReport/recordPlayersReport": 1724,
	"./partner/reports/playersReport/recordPlayersReport.js": 1724,
	"./partner/reports/playersReport/recordTablePlayersReport": 792,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 792,
	"./partner/reports/playersReport/tablePlayersReport": 1725,
	"./partner/reports/playersReport/tablePlayersReport.js": 1725,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1031,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1031,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 789,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 789,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1032,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1032,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 791,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 791,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 790,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 790,
	"./partner/reports/promotionalCodes/filter": 1726,
	"./partner/reports/promotionalCodes/filter.js": 1726,
	"./partner/reports/promotionalCodes/table": 1727,
	"./partner/reports/promotionalCodes/table.js": 1727,
	"./partner/reports/quotaRetraction/filter": 1728,
	"./partner/reports/quotaRetraction/filter.js": 1728,
	"./partner/reports/quotaRetraction/table": 1729,
	"./partner/reports/quotaRetraction/table.js": 1729,
	"./partner/reports/registeredDocument": 1730,
	"./partner/reports/registeredDocument.js": 1730,
	"./partner/reports/registeredDocuments/filter": 793,
	"./partner/reports/registeredDocuments/filter.js": 793,
	"./partner/reports/registeredDocuments/table": 794,
	"./partner/reports/registeredDocuments/table.js": 794,
	"./partner/reports/relationUserAggregator": 1731,
	"./partner/reports/relationUserAggregator.js": 1731,
	"./partner/reports/relationUserAggregator/filter": 795,
	"./partner/reports/relationUserAggregator/filter.js": 795,
	"./partner/reports/relationUserAggregator/table": 796,
	"./partner/reports/relationUserAggregator/table.js": 796,
	"./partner/reports/reportHash/filter": 1732,
	"./partner/reports/reportHash/filter.js": 1732,
	"./partner/reports/reportHash/table": 1733,
	"./partner/reports/reportHash/table.js": 1733,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1734,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1734,
	"./partner/reports/sessionsReport/filterSessionsReport": 1735,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1735,
	"./partner/reports/sessionsReport/recordSessionsReport": 1736,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1736,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1033,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1033,
	"./partner/reports/sessionsReport/tableSessionsReport": 1737,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1737,
	"./partner/reports/sportsTransactions": 1738,
	"./partner/reports/sportsTransactions.js": 1738,
	"./partner/reports/sportsTransactions/filter": 797,
	"./partner/reports/sportsTransactions/filter.js": 797,
	"./partner/reports/sportsTransactions/table": 798,
	"./partner/reports/sportsTransactions/table.js": 798,
	"./partner/reports/summaryCashFlow": 1739,
	"./partner/reports/summaryCashFlow.js": 1739,
	"./partner/reports/taxableEarnings/filter": 1740,
	"./partner/reports/taxableEarnings/filter.js": 1740,
	"./partner/reports/taxableEarnings/table": 1741,
	"./partner/reports/taxableEarnings/table.js": 1741,
	"./partner/reports/transfersReport/filter": 1742,
	"./partner/reports/transfersReport/filter.js": 1742,
	"./partner/reports/transfersReport/table": 1743,
	"./partner/reports/transfersReport/table.js": 1743,
	"./partner/reports/usuarioOnlineResumido": 1744,
	"./partner/reports/usuarioOnlineResumido.js": 1744,
	"./partner/reports/usuarioOnlineResumido/filter": 799,
	"./partner/reports/usuarioOnlineResumido/filter.js": 799,
	"./partner/reports/usuarioOnlineResumido/table": 800,
	"./partner/reports/usuarioOnlineResumido/table.js": 800,
	"./partner/reports/wallets": 1745,
	"./partner/reports/wallets.js": 1745,
	"./partner/reports/wallets/filter": 801,
	"./partner/reports/wallets/filter.js": 801,
	"./partner/reports/wallets/table": 802,
	"./partner/reports/wallets/table.js": 802,
	"./partner/templates": 1746,
	"./partner/templates.js": 1746,
	"./partner/templates/email": 1747,
	"./partner/templates/email.js": 1747,
	"./partner/templates/email/filter": 803,
	"./partner/templates/email/filter.js": 803,
	"./partner/templates/email/table": 804,
	"./partner/templates/email/table.js": 804,
	"./partner/templates/email/template": 805,
	"./partner/templates/email/template.js": 805,
	"./partner/templates/emailTemplate": 1748,
	"./partner/templates/emailTemplate.js": 1748,
	"./partner/templates/pdf": 1749,
	"./partner/templates/pdf.js": 1749,
	"./partner/templates/pdf/filter": 806,
	"./partner/templates/pdf/filter.js": 806,
	"./partner/templates/pdf/table": 807,
	"./partner/templates/pdf/table.js": 807,
	"./partner/templates/pdf/template": 808,
	"./partner/templates/pdf/template.js": 808,
	"./partner/templates/pdfTemplate": 1750,
	"./partner/templates/pdfTemplate.js": 1750,
	"./partner/templates/sms": 1751,
	"./partner/templates/sms.js": 1751,
	"./partner/templates/sms/filter": 809,
	"./partner/templates/sms/filter.js": 809,
	"./partner/templates/sms/table": 810,
	"./partner/templates/sms/table.js": 810,
	"./partner/templates/sms/template": 811,
	"./partner/templates/sms/template.js": 811,
	"./partner/templates/smsTemplate": 1752,
	"./partner/templates/smsTemplate.js": 1752,
	"./partners": 1753,
	"./partners.js": 1753,
	"./partnersCategories": 1754,
	"./partnersCategories.js": 1754,
	"./partnersProducts": 1755,
	"./partnersProducts.js": 1755,
	"./partnersProductsCountry": 1756,
	"./partnersProductsCountry.js": 1756,
	"./partnersProviders": 1757,
	"./partnersProviders.js": 1757,
	"./partnersTypeProduct": 1758,
	"./partnersTypeProduct.js": 1758,
	"./payPrizesLoyalty": 1759,
	"./payPrizesLoyalty.js": 1759,
	"./payhistoryview": 1760,
	"./payhistoryview.js": 1760,
	"./platformSpecific": 1761,
	"./platformSpecific.js": 1761,
	"./platformSpecific2": 1762,
	"./platformSpecific2.js": 1762,
	"./playerAccount": 1763,
	"./playerAccount.js": 1763,
	"./playerAccount2": 1764,
	"./playerAccount2.js": 1764,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1765,
	"./playersList.js": 1765,
	"./playersList2": 1766,
	"./playersList2.js": 1766,
	"./playersListAggregator": 1767,
	"./playersListAggregator.js": 1767,
	"./playersLists": 1768,
	"./playersLists.js": 1768,
	"./playersReport": 1769,
	"./playersReport.js": 1769,
	"./pointSettings": 1770,
	"./pointSettings.js": 1770,
	"./pointsUsers": 1771,
	"./pointsUsers.js": 1771,
	"./pokerReport": 1772,
	"./pokerReport.js": 1772,
	"./prices": 1773,
	"./prices.js": 1773,
	"./prizesLoyalty": 1774,
	"./prizesLoyalty.js": 1774,
	"./products": 1775,
	"./products.js": 1775,
	"./products/activeProviders/filterActiveProviders": 205,
	"./products/activeProviders/filterActiveProviders.js": 205,
	"./products/activeProviders/tableActiveProviders": 206,
	"./products/activeProviders/tableActiveProviders.js": 206,
	"./products/banks/filterBanks": 323,
	"./products/banks/filterBanks.js": 323,
	"./products/banks/tableBanks": 324,
	"./products/banks/tableBanks.js": 324,
	"./products/blockchain-networks/filterBlockchainNetworks": 380,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 380,
	"./products/blockchain-networks/tableBlockchainNetworks": 381,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 381,
	"./products/categories-products/detailsCategoriesProducts": 1016,
	"./products/categories-products/detailsCategoriesProducts.js": 1016,
	"./products/categories-products/filterCategoriesProducts": 423,
	"./products/categories-products/filterCategoriesProducts.js": 423,
	"./products/categories-products/recordCategoriesProducts": 1017,
	"./products/categories-products/recordCategoriesProducts.js": 1017,
	"./products/categories-products/recordTableCategoriesProducts": 425,
	"./products/categories-products/recordTableCategoriesProducts.js": 425,
	"./products/categories-products/tableCategoriesProducts": 424,
	"./products/categories-products/tableCategoriesProducts.js": 424,
	"./products/categories/detailsCategories": 1014,
	"./products/categories/detailsCategories.js": 1014,
	"./products/categories/filterCategories": 420,
	"./products/categories/filterCategories.js": 420,
	"./products/categories/recordCategories": 1015,
	"./products/categories/recordCategories.js": 1015,
	"./products/categories/recordTableCategories": 422,
	"./products/categories/recordTableCategories.js": 422,
	"./products/categories/tableCategories": 421,
	"./products/categories/tableCategories.js": 421,
	"./products/crypto-blockchain/filterCryptoBlockchain": 447,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 447,
	"./products/crypto-blockchain/tableCryptoBlockchain": 448,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 448,
	"./products/cryptos/filterCrypto": 449,
	"./products/cryptos/filterCrypto.js": 449,
	"./products/cryptos/tableCrypto": 450,
	"./products/cryptos/tableCrypto.js": 450,
	"./products/franchises/filterFranchises": 516,
	"./products/franchises/filterFranchises.js": 516,
	"./products/franchises/tableFranchises": 517,
	"./products/franchises/tableFranchises.js": 517,
	"./products/partners-products-country/detailsPartnersProductsCountry": 822,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 822,
	"./products/partners-products-country/filterPartnersProductsCountry": 820,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 820,
	"./products/partners-products-country/recordPartnersProductsCountry": 823,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 823,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 824,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 824,
	"./products/partners-products-country/tablePartnersProductsCountry": 821,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 821,
	"./products/partners-products/detailsPartnersProducts": 818,
	"./products/partners-products/detailsPartnersProducts.js": 818,
	"./products/partners-products/filterPartnersProducts": 816,
	"./products/partners-products/filterPartnersProducts.js": 816,
	"./products/partners-products/recordPartnersProducts": 819,
	"./products/partners-products/recordPartnersProducts.js": 819,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 817,
	"./products/partners-products/tablePartnersProducts.js": 817,
	"./products/partners-providers/details": 827,
	"./products/partners-providers/details.js": 827,
	"./products/partners-providers/filter": 825,
	"./products/partners-providers/filter.js": 825,
	"./products/partners-providers/record": 828,
	"./products/partners-providers/record.js": 828,
	"./products/partners-providers/recordTable": 1776,
	"./products/partners-providers/recordTable.js": 1776,
	"./products/partners-providers/table": 826,
	"./products/partners-providers/table.js": 826,
	"./products/partners-tipoproducto/details": 831,
	"./products/partners-tipoproducto/details.js": 831,
	"./products/partners-tipoproducto/filter": 829,
	"./products/partners-tipoproducto/filter.js": 829,
	"./products/partners-tipoproducto/record": 832,
	"./products/partners-tipoproducto/record.js": 832,
	"./products/partners-tipoproducto/recordTable": 1777,
	"./products/partners-tipoproducto/recordTable.js": 1777,
	"./products/partners-tipoproducto/table": 830,
	"./products/partners-tipoproducto/table.js": 830,
	"./products/partners/filter": 812,
	"./products/partners/filter.js": 812,
	"./products/partners/table": 813,
	"./products/partners/table.js": 813,
	"./products/products/detailsProducts": 1034,
	"./products/products/detailsProducts.js": 1034,
	"./products/products/filterProducts": 854,
	"./products/products/filterProducts.js": 854,
	"./products/products/recordProducts": 1035,
	"./products/products/recordProducts.js": 1035,
	"./products/products/recordTableProducts": 856,
	"./products/products/recordTableProducts.js": 856,
	"./products/products/tableProducts": 855,
	"./products/products/tableProducts.js": 855,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 857,
	"./products/providers/filterProviders.js": 857,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 325,
	"./products/providers/recordTableProviders.js": 325,
	"./products/providers/tableProviders": 858,
	"./products/providers/tableProviders.js": 858,
	"./products/subProviders/filter": 859,
	"./products/subProviders/filter.js": 859,
	"./products/subProviders/table": 860,
	"./products/subProviders/table.js": 860,
	"./products/tags/detailsTags": 1036,
	"./products/tags/detailsTags.js": 1036,
	"./products/tags/filterTags": 861,
	"./products/tags/filterTags.js": 861,
	"./products/tags/recordTableTags": 862,
	"./products/tags/recordTableTags.js": 862,
	"./products/tags/recordTags": 1037,
	"./products/tags/recordTags.js": 1037,
	"./products/tags/tableTags": 863,
	"./products/tags/tableTags.js": 863,
	"./profile": 1778,
	"./profile.js": 1778,
	"./profileOptions": 1779,
	"./profileOptions.js": 1779,
	"./profileOptions2": 1780,
	"./profileOptions2.js": 1780,
	"./profileOptionsOld": 1781,
	"./profileOptionsOld.js": 1781,
	"./promotionalCasinoCampaings": 1782,
	"./promotionalCasinoCampaings.js": 1782,
	"./promotionalCodes": 1783,
	"./promotionalCodes.js": 1783,
	"./promotionalSportbookCampaings": 1784,
	"./promotionalSportbookCampaings.js": 1784,
	"./providers": 1785,
	"./providers.js": 1785,
	"./qualifying": 1786,
	"./qualifying.js": 1786,
	"./quotaRetraction": 1787,
	"./quotaRetraction.js": 1787,
	"./quotaRetractionReport": 1788,
	"./quotaRetractionReport.js": 1788,
	"./recargarCredito": 1789,
	"./recargarCredito.js": 1789,
	"./recargarCreditoAgente": 1790,
	"./recargarCreditoAgente.js": 1790,
	"./referralsAwardsReport": 1791,
	"./referralsAwardsReport.js": 1791,
	"./referralsReport": 1792,
	"./referralsReport.js": 1792,
	"./registerFast": 1793,
	"./registerFast.js": 1793,
	"./registeredDocument": 1794,
	"./registeredDocument.js": 1794,
	"./registeredDocuments": 1795,
	"./registeredDocuments.js": 1795,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 436,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 436,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 437,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 437,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 438,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 438,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 439,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 439,
	"./regulations/futureEvents/filterFutureEventsReports": 518,
	"./regulations/futureEvents/filterFutureEventsReports.js": 518,
	"./regulations/futureEvents/tableFutureEventsReports": 519,
	"./regulations/futureEvents/tableFutureEventsReports.js": 519,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 520,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 520,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 521,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 521,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 522,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 522,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 523,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 523,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 549,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 549,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 550,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 550,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 551,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 551,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 552,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 552,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 553,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 553,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 554,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 554,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 555,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 555,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 556,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 556,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 678,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 678,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 679,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 679,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 680,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 680,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 681,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 681,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 833,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 833,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 834,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 834,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 835,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 835,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 836,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 836,
	"./regulations/playerAccount/filterPlayerAccountReports": 837,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 837,
	"./regulations/playerAccount/tablePlayerAccountReports": 838,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 838,
	"./regulations/playerAccount2/filterPlayerAccountReports": 839,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 839,
	"./regulations/playerAccount2/tablePlayerAccountReports": 840,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 840,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 888,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 888,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 889,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 889,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 890,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 890,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 891,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 891,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 892,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 892,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 893,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 893,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 894,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 894,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 895,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 895,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 896,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 896,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 897,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 897,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 898,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 898,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 899,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 899,
	"./relationUserAggregator": 1796,
	"./relationUserAggregator.js": 1796,
	"./reportHash": 1797,
	"./reportHash.js": 1797,
	"./reportMarketing": 1798,
	"./reportMarketing.js": 1798,
	"./reports/affiliatesBetShop/filter": 209,
	"./reports/affiliatesBetShop/filter.js": 209,
	"./reports/affiliatesBetShop/table": 210,
	"./reports/affiliatesBetShop/table.js": 210,
	"./reports/assignmentQuota/filter": 294,
	"./reports/assignmentQuota/filter.js": 294,
	"./reports/assignmentQuota/table": 295,
	"./reports/assignmentQuota/table.js": 295,
	"./reports/assignmentQuotaMade/filter": 292,
	"./reports/assignmentQuotaMade/filter.js": 292,
	"./reports/assignmentQuotaMade/table": 293,
	"./reports/assignmentQuotaMade/table.js": 293,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 298,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 299,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 297,
	"./reports/balanceAdjustments/filter": 300,
	"./reports/balanceAdjustments/filter.js": 300,
	"./reports/balanceAdjustments/table": 301,
	"./reports/balanceAdjustments/table.js": 301,
	"./reports/balanceHistory/filter": 302,
	"./reports/balanceHistory/filter.js": 302,
	"./reports/balanceHistory/table": 303,
	"./reports/balanceHistory/table.js": 303,
	"./reports/balanceHistory2/filter": 1799,
	"./reports/balanceHistory2/filter.js": 1799,
	"./reports/balanceHistory2/filter2": 304,
	"./reports/balanceHistory2/filter2.js": 304,
	"./reports/balanceHistory2/table": 1800,
	"./reports/balanceHistory2/table.js": 1800,
	"./reports/balanceHistory2/table2": 305,
	"./reports/balanceHistory2/table2.js": 305,
	"./reports/balanceHistoryBetShop/filter": 308,
	"./reports/balanceHistoryBetShop/filter.js": 308,
	"./reports/balanceHistoryBetShop/table": 309,
	"./reports/balanceHistoryBetShop/table.js": 309,
	"./reports/balanceHistoryBetShop2/filter": 1801,
	"./reports/balanceHistoryBetShop2/filter.js": 1801,
	"./reports/balanceHistoryBetShop2/filter2": 310,
	"./reports/balanceHistoryBetShop2/filter2.js": 310,
	"./reports/balanceHistoryBetShop2/table": 1802,
	"./reports/balanceHistoryBetShop2/table.js": 1802,
	"./reports/balanceHistoryBetShop2/table2": 311,
	"./reports/balanceHistoryBetShop2/table2.js": 311,
	"./reports/balanceHistoryForAdminUser/filter": 306,
	"./reports/balanceHistoryForAdminUser/filter.js": 306,
	"./reports/balanceHistoryForAdminUser/table": 307,
	"./reports/balanceHistoryForAdminUser/table.js": 307,
	"./reports/balanceHistoryForAgent/filter": 312,
	"./reports/balanceHistoryForAgent/filter.js": 312,
	"./reports/balanceHistoryForAgent/table": 313,
	"./reports/balanceHistoryForAgent/table.js": 313,
	"./reports/balanceHistoryForBetShop/filter": 314,
	"./reports/balanceHistoryForBetShop/filter.js": 314,
	"./reports/balanceHistoryForBetShop/table": 315,
	"./reports/balanceHistoryForBetShop/table.js": 315,
	"./reports/balanceHistoryMachine/filter": 316,
	"./reports/balanceHistoryMachine/filter.js": 316,
	"./reports/balanceHistoryMachine/table": 317,
	"./reports/balanceHistoryMachine/table.js": 317,
	"./reports/balanceUsers/filter": 318,
	"./reports/balanceUsers/filter.js": 318,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 320,
	"./reports/balanceUsers/resume.js": 320,
	"./reports/balanceUsers/table": 319,
	"./reports/balanceUsers/table.js": 319,
	"./reports/betsReport/detailsReport": 1803,
	"./reports/betsReport/detailsReport.js": 1803,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1804,
	"./reports/betsReportBetShop/detailsReport.js": 1804,
	"./reports/betsReportBetShop/filterReport": 374,
	"./reports/betsReportBetShop/filterReport.js": 374,
	"./reports/betsReportBetShop/recordReport": 377,
	"./reports/betsReportBetShop/recordReport.js": 377,
	"./reports/betsReportBetShop/recordTableReport": 1805,
	"./reports/betsReportBetShop/recordTableReport.js": 1805,
	"./reports/betsReportBetShop/recordTableTransReport": 1806,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1806,
	"./reports/betsReportBetShop/recordTransReport": 376,
	"./reports/betsReportBetShop/recordTransReport.js": 376,
	"./reports/betsReportBetShop/tableReport": 375,
	"./reports/betsReportBetShop/tableReport.js": 375,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 382,
	"./reports/bonusReport/filterBonusReport.js": 382,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 383,
	"./reports/bonusReport/tableBonusReport.js": 383,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 384,
	"./reports/bonusReport2/filterBonusReport.js": 384,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1807,
	"./reports/bonusReport2/recordTableBonusReport.js": 1807,
	"./reports/bonusReport2/tableBonusReport": 385,
	"./reports/bonusReport2/tableBonusReport.js": 385,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 416,
	"./reports/casinoReport/filterCasinoReport.js": 416,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 417,
	"./reports/casinoReport/tableCasinoReport.js": 417,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1808,
	"./reports/casinoReport2/filterCasinoReport.js": 1808,
	"./reports/casinoReport2/filterCasinoReport2": 418,
	"./reports/casinoReport2/filterCasinoReport2.js": 418,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1809,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1809,
	"./reports/casinoReport2/tableCasinoReport": 1810,
	"./reports/casinoReport2/tableCasinoReport.js": 1810,
	"./reports/casinoReport2/tableCasinoReport2": 419,
	"./reports/casinoReport2/tableCasinoReport2.js": 419,
	"./reports/comissions_report/filter": 426,
	"./reports/comissions_report/filter.js": 426,
	"./reports/comissions_report/table": 427,
	"./reports/comissions_report/table.js": 427,
	"./reports/comissions_report2/filter": 428,
	"./reports/comissions_report2/filter.js": 428,
	"./reports/comissions_report2/table": 429,
	"./reports/comissions_report2/table.js": 429,
	"./reports/commisionsPay/filter": 430,
	"./reports/commisionsPay/filter.js": 430,
	"./reports/commisionsPay/table": 431,
	"./reports/commisionsPay/table.js": 431,
	"./reports/coupons_report/details": 1811,
	"./reports/coupons_report/details.js": 1811,
	"./reports/coupons_report/filter": 445,
	"./reports/coupons_report/filter.js": 445,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1812,
	"./reports/coupons_report/recordReports.js": 1812,
	"./reports/coupons_report/table": 446,
	"./reports/coupons_report/table.js": 446,
	"./reports/customReport/filter": 451,
	"./reports/customReport/filter.js": 451,
	"./reports/customReport/table": 452,
	"./reports/customReport/table.js": 452,
	"./reports/depositReport2/filter": 497,
	"./reports/depositReport2/filter.js": 497,
	"./reports/depositReport2/table": 498,
	"./reports/depositReport2/table.js": 498,
	"./reports/deposit_report/detailsDepositReports": 1022,
	"./reports/deposit_report/detailsDepositReports.js": 1022,
	"./reports/deposit_report/filterDepositReports": 495,
	"./reports/deposit_report/filterDepositReports.js": 495,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 496,
	"./reports/deposit_report/tableDepositReports.js": 496,
	"./reports/deposit_report_3/detailsDepositReports": 1023,
	"./reports/deposit_report_3/detailsDepositReports.js": 1023,
	"./reports/deposit_report_3/filterDepositReports": 499,
	"./reports/deposit_report_3/filterDepositReports.js": 499,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1813,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1813,
	"./reports/deposit_report_3/tableDepositReports": 500,
	"./reports/deposit_report_3/tableDepositReports.js": 500,
	"./reports/deposit_report_betshop/detailsDepositReports": 1024,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1024,
	"./reports/deposit_report_betshop/filterDepositReports": 501,
	"./reports/deposit_report_betshop/filterDepositReports.js": 501,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1814,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1814,
	"./reports/deposit_report_betshop/tableDepositReports": 502,
	"./reports/deposit_report_betshop/tableDepositReports.js": 502,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 510,
	"./reports/emailsReport/filterEmailsReport.js": 510,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1815,
	"./reports/emailsReport/recordTableEmailsReport.js": 1815,
	"./reports/emailsReport/tableEmailsReport": 511,
	"./reports/emailsReport/tableEmailsReport.js": 511,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 906,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 906,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 907,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 907,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 908,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 908,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 909,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 909,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 910,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 910,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1816,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1816,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 911,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 911,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 912,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 912,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1817,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1817,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1818,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1818,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 913,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 913,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 914,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 915,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 915,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 916,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 916,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1819,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1819,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 917,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 917,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 526,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 526,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 524,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 524,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 527,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 527,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 528,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 528,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 525,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 525,
	"./reports/historyMovement/filter": 529,
	"./reports/historyMovement/filter.js": 529,
	"./reports/historyMovement/table": 530,
	"./reports/historyMovement/table.js": 530,
	"./reports/historyMovementBetShop/filter": 531,
	"./reports/historyMovementBetShop/filter.js": 531,
	"./reports/historyMovementBetShop/table": 532,
	"./reports/historyMovementBetShop/table.js": 532,
	"./reports/historyPoints/filter": 533,
	"./reports/historyPoints/filter.js": 533,
	"./reports/historyPoints/table": 534,
	"./reports/historyPoints/table.js": 534,
	"./reports/informeCasino/detailsInformeCasino": 537,
	"./reports/informeCasino/detailsInformeCasino.js": 537,
	"./reports/informeCasino/filterInformeCasino": 535,
	"./reports/informeCasino/filterInformeCasino.js": 535,
	"./reports/informeCasino/recordInformeCasino": 538,
	"./reports/informeCasino/recordInformeCasino.js": 538,
	"./reports/informeCasino/recordTableInformeCasino": 1820,
	"./reports/informeCasino/recordTableInformeCasino.js": 1820,
	"./reports/informeCasino/tableInformeCasino": 536,
	"./reports/informeCasino/tableInformeCasino.js": 536,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome": 435,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome.js": 435,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome": 434,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome.js": 434,
	"./reports/informeGerencial/detailsInformeGerencial": 1821,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1821,
	"./reports/informeGerencial/filterInformeGerencial": 539,
	"./reports/informeGerencial/filterInformeGerencial.js": 539,
	"./reports/informeGerencial/recordInformeGerencial": 1822,
	"./reports/informeGerencial/recordInformeGerencial.js": 1822,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 540,
	"./reports/informeGerencial/tableInformeGerencial.js": 540,
	"./reports/informeGerencial2/detailsInformeGerencial": 1823,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1823,
	"./reports/informeGerencial2/filterInformeGerencial": 1824,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1824,
	"./reports/informeGerencial2/filterInformeGerencial2": 541,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 541,
	"./reports/informeGerencial2/recordInformeGerencial": 1825,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1825,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1826,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1826,
	"./reports/informeGerencial2/tableInformeGerencial": 1827,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1827,
	"./reports/informeGerencial2/tableInformeGerencial2": 542,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 542,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1828,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1828,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1829,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1829,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 543,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 543,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1830,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1830,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1831,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1831,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1832,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1832,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 544,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 544,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1833,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1833,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1834,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1834,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 545,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 545,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1835,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1835,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1836,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1836,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1837,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1837,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 546,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 546,
	"./reports/jackpotInternationalReport/filter": 547,
	"./reports/jackpotInternationalReport/filter.js": 547,
	"./reports/jackpotInternationalReport/table": 548,
	"./reports/jackpotInternationalReport/table.js": 548,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 557,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 557,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1838,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1838,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1839,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1839,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 558,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 558,
	"./reports/landingReport/detailsLandingReport": 561,
	"./reports/landingReport/detailsLandingReport.js": 561,
	"./reports/landingReport/filterLandingReport": 559,
	"./reports/landingReport/filterLandingReport.js": 559,
	"./reports/landingReport/recordLandingReport": 562,
	"./reports/landingReport/recordLandingReport.js": 562,
	"./reports/landingReport/recordTableLandingReport": 1840,
	"./reports/landingReport/recordTableLandingReport.js": 1840,
	"./reports/landingReport/tableLandingReport": 560,
	"./reports/landingReport/tableLandingReport.js": 560,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 563,
	"./reports/landingReport2/filterLandingReport.js": 563,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1841,
	"./reports/landingReport2/recordTableLandingReport.js": 1841,
	"./reports/landingReport2/tableLandingReport": 564,
	"./reports/landingReport2/tableLandingReport.js": 564,
	"./reports/limitationsReport/filterDepositReports": 581,
	"./reports/limitationsReport/filterDepositReports.js": 581,
	"./reports/limitationsReport/tableDepositReports": 582,
	"./reports/limitationsReport/tableDepositReports.js": 582,
	"./reports/logsUser/filter": 585,
	"./reports/logsUser/filter.js": 585,
	"./reports/logsUser/table": 586,
	"./reports/logsUser/table.js": 586,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 587,
	"./reports/loteryReport/filterLoteryReport.js": 587,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1842,
	"./reports/loteryReport/recordTableLoteryReport.js": 1842,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 588,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 588,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 589,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 589,
	"./reports/my_comissions_report/filter": 672,
	"./reports/my_comissions_report/filter.js": 672,
	"./reports/my_comissions_report/table": 673,
	"./reports/my_comissions_report/table.js": 673,
	"./reports/notesUser/filter": 674,
	"./reports/notesUser/filter.js": 674,
	"./reports/notesUser/table": 675,
	"./reports/notesUser/table.js": 675,
	"./reports/operatorResponsibility/filter": 676,
	"./reports/operatorResponsibility/filter.js": 676,
	"./reports/operatorResponsibility/table": 677,
	"./reports/operatorResponsibility/table.js": 677,
	"./reports/partners-categories/filter": 814,
	"./reports/partners-categories/filter.js": 814,
	"./reports/partners-categories/table": 815,
	"./reports/partners-categories/table.js": 815,
	"./reports/playersReport/detailsPlayersReport": 843,
	"./reports/playersReport/detailsPlayersReport.js": 843,
	"./reports/playersReport/filterPlayersReport": 841,
	"./reports/playersReport/filterPlayersReport.js": 841,
	"./reports/playersReport/recordPlayersReport": 844,
	"./reports/playersReport/recordPlayersReport.js": 844,
	"./reports/playersReport/recordTablePlayersReport": 845,
	"./reports/playersReport/recordTablePlayersReport.js": 845,
	"./reports/playersReport/tablePlayersReport": 842,
	"./reports/playersReport/tablePlayersReport.js": 842,
	"./reports/pointSettings/filter": 846,
	"./reports/pointSettings/filter.js": 846,
	"./reports/pointSettings/table": 847,
	"./reports/pointSettings/table.js": 847,
	"./reports/pointsUsers/filter": 848,
	"./reports/pointsUsers/filter.js": 848,
	"./reports/pointsUsers/table": 849,
	"./reports/pointsUsers/table.js": 849,
	"./reports/pokerReport/filterCasinoReport": 850,
	"./reports/pokerReport/filterCasinoReport.js": 850,
	"./reports/pokerReport/tableCasinoReport": 851,
	"./reports/pokerReport/tableCasinoReport.js": 851,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1843,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1843,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 682,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 682,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1844,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1844,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 918,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 918,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 683,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 683,
	"./reports/prizesLoyalty/filter": 852,
	"./reports/prizesLoyalty/filter.js": 852,
	"./reports/prizesLoyalty/table": 853,
	"./reports/prizesLoyalty/table.js": 853,
	"./reports/promotionalCasinoCampaings/filter": 869,
	"./reports/promotionalCasinoCampaings/filter.js": 869,
	"./reports/promotionalCasinoCampaings/table": 870,
	"./reports/promotionalCasinoCampaings/table.js": 870,
	"./reports/promotionalCodes/filter": 871,
	"./reports/promotionalCodes/filter.js": 871,
	"./reports/promotionalCodes/table": 872,
	"./reports/promotionalCodes/table.js": 872,
	"./reports/promotionalSpoortbookCampaings/filter": 873,
	"./reports/promotionalSpoortbookCampaings/filter.js": 873,
	"./reports/promotionalSpoortbookCampaings/table": 874,
	"./reports/promotionalSpoortbookCampaings/table.js": 874,
	"./reports/quotaRetraction/filter": 877,
	"./reports/quotaRetraction/filter.js": 877,
	"./reports/quotaRetraction/table": 878,
	"./reports/quotaRetraction/table.js": 878,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 879,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 879,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1845,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1845,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1846,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1846,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 880,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 880,
	"./reports/referralsReport/filterReferralsReports": 881,
	"./reports/referralsReport/filterReferralsReports.js": 881,
	"./reports/referralsReport/recordReferralsReports": 1847,
	"./reports/referralsReport/recordReferralsReports.js": 1847,
	"./reports/referralsReport/recordTableReferralsReports": 1848,
	"./reports/referralsReport/recordTableReferralsReports.js": 1848,
	"./reports/referralsReport/tableReferralsReports": 882,
	"./reports/referralsReport/tableReferralsReports.js": 882,
	"./reports/registeredDocuments/filter": 883,
	"./reports/registeredDocuments/filter.js": 883,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 885,
	"./reports/registeredDocuments/recordTable.js": 885,
	"./reports/registeredDocuments/table": 884,
	"./reports/registeredDocuments/table.js": 884,
	"./reports/relationUserAggregator/filter": 900,
	"./reports/relationUserAggregator/filter.js": 900,
	"./reports/relationUserAggregator/table": 901,
	"./reports/relationUserAggregator/table.js": 901,
	"./reports/reportHash/filter": 902,
	"./reports/reportHash/filter.js": 902,
	"./reports/reportHash/table": 903,
	"./reports/reportHash/table.js": 903,
	"./reports/reportMarketing/filter": 904,
	"./reports/reportMarketing/filter.js": 904,
	"./reports/reportMarketing/table": 905,
	"./reports/reportMarketing/table.js": 905,
	"./reports/rouletteReport/filter": 919,
	"./reports/rouletteReport/filter.js": 919,
	"./reports/rouletteReport/table": 920,
	"./reports/rouletteReport/table.js": 920,
	"./reports/sessionsReport/detailsSessionsReport": 921,
	"./reports/sessionsReport/detailsSessionsReport.js": 921,
	"./reports/sessionsReport/filterSessionsReport": 922,
	"./reports/sessionsReport/filterSessionsReport.js": 922,
	"./reports/sessionsReport/recordSessionsReport": 1038,
	"./reports/sessionsReport/recordSessionsReport.js": 1038,
	"./reports/sessionsReport/recordTableSessionsReport": 1039,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1039,
	"./reports/sessionsReport/tableSessionsReport": 923,
	"./reports/sessionsReport/tableSessionsReport.js": 923,
	"./reports/sessionsReport2/filter": 924,
	"./reports/sessionsReport2/filter.js": 924,
	"./reports/sessionsReport2/table": 925,
	"./reports/sessionsReport2/table.js": 925,
	"./reports/sportsPoolReport/filterReport": 926,
	"./reports/sportsPoolReport/filterReport.js": 926,
	"./reports/sportsPoolReport/tableReport": 927,
	"./reports/sportsPoolReport/tableReport.js": 927,
	"./reports/sportsTransactions/filter": 928,
	"./reports/sportsTransactions/filter.js": 928,
	"./reports/sportsTransactions/table": 929,
	"./reports/sportsTransactions/table.js": 929,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 930,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 930,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 931,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 931,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 932,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 932,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1849,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1849,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 933,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 933,
	"./reports/taxPaymentsReport/filter": 934,
	"./reports/taxPaymentsReport/filter.js": 934,
	"./reports/taxPaymentsReport/table": 935,
	"./reports/taxPaymentsReport/table.js": 935,
	"./reports/taxableEarnings/filter": 936,
	"./reports/taxableEarnings/filter.js": 936,
	"./reports/taxableEarnings/table": 937,
	"./reports/taxableEarnings/table.js": 937,
	"./reports/transactionReport/filter": 938,
	"./reports/transactionReport/filter.js": 938,
	"./reports/transactionReport/table": 939,
	"./reports/transactionReport/table.js": 939,
	"./reports/transfersReport/filter": 940,
	"./reports/transfersReport/filter.js": 940,
	"./reports/transfersReport/table": 941,
	"./reports/transfersReport/table.js": 941,
	"./reports/userAffiliatesAgent/filter": 942,
	"./reports/userAffiliatesAgent/filter.js": 942,
	"./reports/userAffiliatesAgent/table": 943,
	"./reports/userAffiliatesAgent/table.js": 943,
	"./reports/userAffiliatesBetShop/filter": 944,
	"./reports/userAffiliatesBetShop/filter.js": 944,
	"./reports/userAffiliatesBetShop/table": 945,
	"./reports/userAffiliatesBetShop/table.js": 945,
	"./reports/usuarioOnlineResumido/filter": 946,
	"./reports/usuarioOnlineResumido/filter.js": 946,
	"./reports/usuarioOnlineResumido/table": 947,
	"./reports/usuarioOnlineResumido/table.js": 947,
	"./reports/withdrawalReport2/filter": 948,
	"./reports/withdrawalReport2/filter.js": 948,
	"./reports/withdrawalReport2/table": 949,
	"./reports/withdrawalReport2/table.js": 949,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 950,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 950,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 951,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 951,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1850,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1850,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 952,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 952,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 953,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 953,
	"./reports/withdrawalRequestsComissions/filter": 954,
	"./reports/withdrawalRequestsComissions/filter.js": 954,
	"./reports/withdrawalRequestsComissions/table": 955,
	"./reports/withdrawalRequestsComissions/table.js": 955,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 956,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 956,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 957,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 957,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 958,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 958,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1851,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1851,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 959,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 959,
	"./reprintCheck": 1852,
	"./reprintCheck.js": 1852,
	"./requests/registration-requests/filter": 960,
	"./requests/registration-requests/filter.js": 960,
	"./requests/registration-requests/generateRequests": 961,
	"./requests/registration-requests/generateRequests.js": 961,
	"./requests/registration-requests/recordTableResponts": 962,
	"./requests/registration-requests/recordTableResponts.js": 962,
	"./requests/registration-requests/table": 964,
	"./requests/registration-requests/table.js": 964,
	"./requests/registration-requests/tableResponts": 963,
	"./requests/registration-requests/tableResponts.js": 963,
	"./requests/registrationRequests": 1853,
	"./requests/registrationRequests.js": 1853,
	"./resources-locale_es.json": 1955,
	"./restrictUser": 1854,
	"./restrictUser.js": 1854,
	"./reversionReload": 1855,
	"./reversionReload.js": 1855,
	"./rouletteReport": 1856,
	"./rouletteReport.js": 1856,
	"./security/adminuser/addAdminUser": 1857,
	"./security/adminuser/addAdminUser.js": 1857,
	"./security/adminuser/configuration/changePassword": 1858,
	"./security/adminuser/configuration/changePassword.js": 1858,
	"./security/adminuser/configuration/changePassword/changePasswordView": 965,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 965,
	"./security/adminuser/configuration/generateToken": 1859,
	"./security/adminuser/configuration/generateToken.js": 1859,
	"./security/adminuser/configuration/generateToken/filter": 966,
	"./security/adminuser/configuration/generateToken/filter.js": 966,
	"./security/adminuser/configuration/generateToken/table": 967,
	"./security/adminuser/configuration/generateToken/table.js": 967,
	"./security/adminuser/configuration/qrgoogle": 1860,
	"./security/adminuser/configuration/qrgoogle.js": 1860,
	"./security/adminuser/configuration/securityChanges": 1861,
	"./security/adminuser/configuration/securityChanges.js": 1861,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1862,
	"./security/adminuser/configurationAdminUser.js": 1862,
	"./security/adminuser/detailsAdminUser": 1863,
	"./security/adminuser/detailsAdminUser.js": 1863,
	"./security/adminuser/filterAdminUser": 207,
	"./security/adminuser/filterAdminUser.js": 207,
	"./security/adminuser/informationAdminUser": 1864,
	"./security/adminuser/informationAdminUser.js": 1864,
	"./security/adminuser/recordAdminUser": 1865,
	"./security/adminuser/recordAdminUser.js": 1865,
	"./security/adminuser/recordTableAdminUser": 968,
	"./security/adminuser/recordTableAdminUser.js": 968,
	"./security/adminuser/reports/logsUser": 1866,
	"./security/adminuser/reports/logsUser.js": 1866,
	"./security/adminuser/reports/logsUser/filter": 969,
	"./security/adminuser/reports/logsUser/filter.js": 969,
	"./security/adminuser/reports/logsUser/table": 970,
	"./security/adminuser/reports/logsUser/table.js": 970,
	"./security/adminuser/reportsAdminUser": 1867,
	"./security/adminuser/reportsAdminUser.js": 1867,
	"./security/adminuser/tableAdminUser": 208,
	"./security/adminuser/tableAdminUser.js": 208,
	"./security/approvalLogs/filter": 286,
	"./security/approvalLogs/filter.js": 286,
	"./security/approvalLogs/table": 287,
	"./security/approvalLogs/table.js": 287,
	"./security/approvalLogs2/filter": 288,
	"./security/approvalLogs2/filter.js": 288,
	"./security/approvalLogs2/table": 289,
	"./security/approvalLogs2/table.js": 289,
	"./security/approvalLogsBetShop/filter": 290,
	"./security/approvalLogsBetShop/filter.js": 290,
	"./security/approvalLogsBetShop/table": 291,
	"./security/approvalLogsBetShop/table.js": 291,
	"./security/contingencia/detailsContingencia": 1868,
	"./security/contingencia/detailsContingencia.js": 1868,
	"./security/contingencia/filterContingencia": 440,
	"./security/contingencia/filterContingencia.js": 440,
	"./security/contingencia/recordContingencia": 1869,
	"./security/contingencia/recordContingencia.js": 1869,
	"./security/contingencia/recordTableContingencia": 971,
	"./security/contingencia/recordTableContingencia.js": 971,
	"./security/contingencia/tableContingencia": 441,
	"./security/contingencia/tableContingencia.js": 441,
	"./security/menu/filter": 662,
	"./security/menu/filter.js": 662,
	"./security/menu/table": 663,
	"./security/menu/table.js": 663,
	"./security/perfil/detailsPerfil": 866,
	"./security/perfil/detailsPerfil.js": 866,
	"./security/perfil/filterPerfil": 864,
	"./security/perfil/filterPerfil.js": 864,
	"./security/perfil/recordPerfil": 867,
	"./security/perfil/recordPerfil.js": 867,
	"./security/perfil/recordTablePerfil": 868,
	"./security/perfil/recordTablePerfil.js": 868,
	"./security/perfil/tablePerfil": 865,
	"./security/perfil/tablePerfil.js": 865,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1870,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1870,
	"./security/perfilopciones2/filterPerfilOpciones": 1871,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1871,
	"./security/perfilopciones2/recordPerfilOpciones": 1872,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1872,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1873,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1873,
	"./security/perfilopciones2/tablePerfilOpciones": 1874,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1874,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1875,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1875,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1876,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1876,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1877,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1877,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1878,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1878,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1879,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1879,
	"./security/submenu/detailsSubMenu": 972,
	"./security/submenu/detailsSubMenu.js": 972,
	"./security/submenu/filterSubMenu": 973,
	"./security/submenu/filterSubMenu.js": 973,
	"./security/submenu/recordSubMenu": 974,
	"./security/submenu/recordSubMenu.js": 974,
	"./security/submenu/recordTableSubMenu": 975,
	"./security/submenu/recordTableSubMenu.js": 975,
	"./security/submenu/tableSubMenu": 976,
	"./security/submenu/tableSubMenu.js": 976,
	"./security/totalContingencies/table": 977,
	"./security/totalContingencies/table.js": 977,
	"./security/userSitebuilder/filter": 978,
	"./security/userSitebuilder/filter.js": 978,
	"./security/userSitebuilder/information": 1880,
	"./security/userSitebuilder/information.js": 1880,
	"./security/userSitebuilder/table": 979,
	"./security/userSitebuilder/table.js": 979,
	"./security/userVerification2/filter": 980,
	"./security/userVerification2/filter.js": 980,
	"./security/userVerification2/information": 1881,
	"./security/userVerification2/information.js": 1881,
	"./security/userVerification2/table": 981,
	"./security/userVerification2/table.js": 981,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1882,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1882,
	"./security/usuarioperfil/filterUsuarioPerfil": 982,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 982,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 983,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 983,
	"./security/usuarioperfil/recordUsuarioPerfil": 1883,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1883,
	"./security/usuarioperfil/tableUsuarioPerfil": 984,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 984,
	"./security/usuariosbloqueados/add": 1884,
	"./security/usuariosbloqueados/add.js": 1884,
	"./security/usuariosbloqueados/filter": 985,
	"./security/usuariosbloqueados/filter.js": 985,
	"./security/usuariosbloqueados/table": 986,
	"./security/usuariosbloqueados/table.js": 986,
	"./security/wallets/filter": 987,
	"./security/wallets/filter.js": 987,
	"./security/wallets/table": 988,
	"./security/wallets/table.js": 988,
	"./sessionsReport": 1885,
	"./sessionsReport.js": 1885,
	"./sessionsReport2": 1886,
	"./sessionsReport2.js": 1886,
	"./settings": 1887,
	"./settings.js": 1887,
	"./significantEventsAndAlterations": 1888,
	"./significantEventsAndAlterations.js": 1888,
	"./significantEventsAndAlterations2": 1889,
	"./significantEventsAndAlterations2.js": 1889,
	"./sportsPoolReport": 1890,
	"./sportsPoolReport.js": 1890,
	"./sportsTransactions": 1891,
	"./sportsTransactions.js": 1891,
	"./subMenu": 1892,
	"./subMenu.js": 1892,
	"./subProviders": 1893,
	"./subProviders.js": 1893,
	"./summaryBetsReport": 1894,
	"./summaryBetsReport.js": 1894,
	"./summaryCashFlow": 1895,
	"./summaryCashFlow.js": 1895,
	"./summaryCashFlow2": 1896,
	"./summaryCashFlow2.js": 1896,
	"./summaryCashFlowMachine": 1897,
	"./summaryCashFlowMachine.js": 1897,
	"./tags": 1898,
	"./tags.js": 1898,
	"./taxPaymentsReport": 1899,
	"./taxPaymentsReport.js": 1899,
	"./taxableEarnings": 1900,
	"./taxableEarnings.js": 1900,
	"./teacher/concessionaire/filterConcessionaire": 514,
	"./teacher/concessionaire/filterConcessionaire.js": 514,
	"./teacher/concessionaire/tableConcessionaire": 515,
	"./teacher/concessionaire/tableConcessionaire.js": 515,
	"./teacher/qualifying/filterQualifying": 875,
	"./teacher/qualifying/filterQualifying.js": 875,
	"./teacher/qualifying/tableQualifying": 876,
	"./teacher/qualifying/tableQualifying.js": 876,
	"./teacher/registered-documents/filterRegisteredDocuments": 886,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 886,
	"./teacher/registered-documents/tableRegisteredDocuments": 887,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 887,
	"./termsAndConditions": 1901,
	"./termsAndConditions.js": 1901,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 442,
	"./tools/countries/filter.js": 442,
	"./tools/countries/table": 443,
	"./tools/countries/table.js": 443,
	"./tools/currencyManagement/currencyFilters": 171,
	"./tools/currencyManagement/currencyFilters.js": 171,
	"./tools/currencyManagement/currencyTable": 172,
	"./tools/currencyManagement/currencyTable.js": 172,
	"./tools/translationManager": 1902,
	"./tools/translationManager.js": 1902,
	"./tools/translationManager/filter": 989,
	"./tools/translationManager/filter.js": 989,
	"./tools/translationManager/table": 990,
	"./tools/translationManager/table.js": 990,
	"./tools/uploadImage": 1903,
	"./tools/uploadImage.js": 1903,
	"./top": 1904,
	"./top.js": 1904,
	"./totalContingencies": 1905,
	"./totalContingencies.js": 1905,
	"./transactionReport": 1906,
	"./transactionReport.js": 1906,
	"./transactions": 1907,
	"./transactions.js": 1907,
	"./transactionsByPlayer": 1908,
	"./transactionsByPlayer.js": 1908,
	"./transactionsByPlayerDeposit": 1909,
	"./transactionsByPlayerDeposit.js": 1909,
	"./transactionsByPlayerFirstLevel": 1910,
	"./transactionsByPlayerFirstLevel.js": 1910,
	"./transactionsByPlayerSecondLevel": 1911,
	"./transactionsByPlayerSecondLevel.js": 1911,
	"./trasnfersReport": 1912,
	"./trasnfersReport.js": 1912,
	"./tutorials": 1913,
	"./tutorials.js": 1913,
	"./userAffiliatesAgent": 1914,
	"./userAffiliatesAgent.js": 1914,
	"./userAffiliatesBetShop": 1915,
	"./userAffiliatesBetShop.js": 1915,
	"./userManagement": 1916,
	"./userManagement.js": 1916,
	"./userManagement/userManagement/detailsUserManagement": 993,
	"./userManagement/userManagement/detailsUserManagement.js": 993,
	"./userManagement/userManagement/filterUserManagement": 991,
	"./userManagement/userManagement/filterUserManagement.js": 991,
	"./userManagement/userManagement/recordTableUserManagement": 995,
	"./userManagement/userManagement/recordTableUserManagement.js": 995,
	"./userManagement/userManagement/recordUserManagement": 994,
	"./userManagement/userManagement/recordUserManagement.js": 994,
	"./userManagement/userManagement/tableUserManagement": 992,
	"./userManagement/userManagement/tableUserManagement.js": 992,
	"./userProfile": 1917,
	"./userProfile.js": 1917,
	"./usersSitebuilder": 1918,
	"./usersSitebuilder.js": 1918,
	"./usersVerification": 1919,
	"./usersVerification.js": 1919,
	"./usersVerification/information": 996,
	"./usersVerification/information.js": 996,
	"./usersVerification2": 1920,
	"./usersVerification2.js": 1920,
	"./usersVerificationManagement": 1921,
	"./usersVerificationManagement.js": 1921,
	"./usuarioOnlineResumido": 1922,
	"./usuarioOnlineResumido.js": 1922,
	"./usuariosbloqueados": 1923,
	"./usuariosbloqueados.js": 1923,
	"./verifyAccount": 1924,
	"./verifyAccount.js": 1924,
	"./verifyAccountAgent": 1925,
	"./verifyAccountAgent.js": 1925,
	"./verifyAccountJumio": 1926,
	"./verifyAccountJumio.js": 1926,
	"./wallets": 1927,
	"./wallets.js": 1927,
	"./watchListReport": 1928,
	"./watchListReport.js": 1928,
	"./watchListReport/filterReport": 997,
	"./watchListReport/filterReport.js": 997,
	"./watchListReport/tableReport": 998,
	"./watchListReport/tableReport.js": 998,
	"./widgets": 1929,
	"./widgets.js": 1929,
	"./withdrawal": 1930,
	"./withdrawal.js": 1930,
	"./withdrawalReport2": 1931,
	"./withdrawalReport2.js": 1931,
	"./withdrawalRequests": 1932,
	"./withdrawalRequests.js": 1932,
	"./withdrawalRequestsBetShop": 1933,
	"./withdrawalRequestsBetShop.js": 1933,
	"./withdrawalRequestsComissions": 1934,
	"./withdrawalRequestsComissions.js": 1934,
	"./withdrawalRequestsForBetShop": 1935,
	"./withdrawalRequestsForBetShop.js": 1935,
	"./withdrawalRequestsForBetShop2": 1936,
	"./withdrawalRequestsForBetShop2.js": 1936,
	"./withdrawalRequestsRetail": 1937,
	"./withdrawalRequestsRetail.js": 1937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1947;